// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:22:53.902Z
// Property: The Otis (ID: 6767906449167337)
// Collections: 36 amenities, 15 floorplans (live), 65 photos, 40 POIs, 10 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167337",
  "property_external_id": "100160108",
  "property_zillow_url": "https://www.zillow.com/apartments/macon-ga/the-otis/5XhtFP/",
  "property_apartments_url": "https://www.apartments.com/the-otis-macon-ga/qb5j8cx/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Otis/data=!4m2!3m1!1s0x0:0x4f1a44df46f509f3?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "31274700124",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-otis",
  "property_name": "The Otis",
  "property_website_url": "https://www.liveattheotis.com/",
  "property_domain": "https://www.liveattheotis.com/",
  "property_address": "6001 Thomaston Rd",
  "property_full_address": "6001 Thomaston Rd, Macon, GA 31220",
  "property_address_1": "6001 Thomaston Rd",
  "property_address_2": null,
  "property_address_city": "Macon",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "31220",
  "property_address_country": "US",
  "property_address_county": "Bibb County",
  "property_neighborhood_address": "Bibb County",
  "property_address_latitude": "32.8454483",
  "property_address_longitude": "-83.7537407",
  "property_email": null,
  "property_phone": "(478) 292-5510",
  "property_call_tracking_phone": "762-701-2693",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Embrace a vibrant lifestyle at The Otis in Macon, GA. Choose from spacious one, two, or three-bedroom floor plans, all nestled within a gated community. Enjoy top-tier amenities like a resort-style pool, fitness center, and a dog park. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Discover The Otis – Your Ideal Apartment Community in Macon, GA**\n\nWelcome to The Otis, an exceptional apartment community that offers the perfect blend of comfort, convenience, and modern living. Nestled in the heart of Macon, GA, The Otis features elegant one, two, and three-bedroom floor plans designed to fit your lifestyle. Each of our apartments showcases modern finishes, including quartz countertops, sleek black appliances, and spacious walk-in closets, ensuring you have everything you need to feel right at home.\n\nAt The Otis, our residents enjoy a range of outstanding amenities that elevate everyday living. Unwind at our resort-style swimming pool, host summer barbecues at the poolside grilling area, or challenge friends to a game of sand volleyball. The community clubhouse serves as a perfect gathering spot, while our state-of-the-art fitness center helps you maintain an active lifestyle. With a dedicated dog park and a playground, furry friends and little ones alike can let loose and have fun in a safe environment.\n\nSafety and convenience are paramount at The Otis. Enjoy peace of mind in our gated community, supported by professional onsite management and maintenance-free living. Additional features include high-speed internet access, washer/dryer connections, and pre-wired security systems in select units.\n\nLocated with easy access to Highway 475, exploring all that Macon has to offer is a breeze. Whether you’re commuting to work or heading out for shopping and entertainment, you’ll love the convenience of our prime location.\n\nFind your new home today – browse our availability or schedule a tour to visit The Otis community and experience the lifestyle you deserve!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-d78f-71cb-a02e-81fc6197588a.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool and lounge area next to the clubhouse.",
    "public_id": "019d54f9-d78f-71cb-a02e-81fc6197588a",
    "storage_key": "property/6767906449167337/019d54f9-d78f-71cb-a02e-81fc6197588a.webp",
    "width": 1900,
    "height": 1120
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "175",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit (Refundable)\n$500.00",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "breed restrictions apply",
  "property_pet_policy_description": "We welcome cats and dogs (breed restrictions apply). Maximum of 2 pets per unit. One-time pet fee: $400. Monthly pet rent: $25.",
  "property_petpolicy_info": "\nPet Policy\nPet Types: Cats & Dogs\nBreed Restrictions Apply\nMaximum Pets Per Unit: 2\n\nPet Fees\nFee: $400.00\nRent: $25.00\n\nAdditional Pet Fees\nFee: $250.00\nRent: $25.00",
  "property_online_leasing_url": "https://theotisaxia.prospectportal.com/Macon/The Otis",
  "property_resident_portal_url": "https://theotisaxia.residentportal.com/auth",
  "property_apply_now_url": "https://theotisaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160108/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d9c4e-87e6-7016-86c0-985973338b19.webp",
  "property_primary_logo_media": {
    "alt_text": "The Otis logo",
    "public_id": "019d9c4e-87e6-7016-86c0-985973338b19",
    "storage_key": "property/6767906449167337/019d9c4e-87e6-7016-86c0-985973338b19.webp",
    "width": 500,
    "height": 300
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d9c4e-83d2-7613-a950-7c3d32f21d60.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Otis logo featuring a record player and the name 'the otis'.",
    "public_id": "019d9c4e-83d2-7613-a950-7c3d32f21d60",
    "storage_key": "property/6767906449167337/019d9c4e-83d2-7613-a950-7c3d32f21d60.webp",
    "width": 500,
    "height": 300
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d9c4e-8599-74ff-a9e7-6a2f422a8d89.webp",
  "property_icon_media": {
    "alt_text": "Icon of a vinyl record player",
    "public_id": "019d9c4e-8599-74ff-a9e7-6a2f422a8d89",
    "storage_key": "property/6767906449167337/019d9c4e-8599-74ff-a9e7-6a2f422a8d89.webp",
    "width": 500,
    "height": 300
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d9c4e-88d3-779f-bf5c-b528b705eeac.webp",
  "property_fav_icon_media": {
    "alt_text": "Icon of a vinyl record on a turntable.",
    "public_id": "019d9c4e-88d3-779f-bf5c-b528b705eeac",
    "storage_key": "property/6767906449167337/019d9c4e-88d3-779f-bf5c-b528b705eeac.webp",
    "width": 500,
    "height": 300
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fa-035f-74e1-8b07-a423fa257302.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d54fa-035f-74e1-8b07-a423fa257302",
    "storage_key": "property/6767906449167337/019d54fa-035f-74e1-8b07-a423fa257302.webp",
    "width": 191,
    "height": 80
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-f739-7759-8af8-a259415c32c1.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d54f9-f739-7759-8af8-a259415c32c1",
    "storage_key": "property/6767906449167337/019d54f9-f739-7759-8af8-a259415c32c1.webp",
    "width": 191,
    "height": 80
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "881 - 1400",
  "property_sqft_min": "881",
  "property_sqft_max": "1400",
  "property_price_range": "$1289 - $1755",
  "property_price_min": "1289",
  "property_price_max": "1755",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/theotisapartments/",
  "property_instagram_url": "https://www.instagram.com/liveattheotis/",
  "property_twitter_url": "https://x.com/liveattheotis",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJF28ePOX584gR8wn1Rt9EGk8",
  "property_youtube_url": "https://www.youtube.com/watch?v=2DU1o7S_EEo",
  "property_yelp_url": "https://www.yelp.com/biz/the-allergy-asthma-and-sinus-center-macon-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Otis",
  "property_home_romance_title": "Embrace Serenity and Charm in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to The Otis in Macon, GA, where modern comfort meets vibrant community living. Enjoy our resort-style pool, fitness center, and pet-friendly spaces, all within a gated haven. With top-notch amenities and stylish apartment features, your ideal home awaits—just moments from Highway 475. Experience maintenance-free living today!",
  "property_home_floorplans_blurb": "Welcome to The Otis in Macon, GA, where modern living meets comfort. With thoughtfully designed one, two, and three-bedroom floor plans, each apartment exudes style and functionality. Dive into our vibrant community and uncover the space that perfectly suits your lifestyle. Your ideal home awaits—browse our available options today!",
  "property_home_gallery_blurb": "Welcome to The Otis, where comfort meets convenience in Macon, GA. Enjoy resort-style amenities like a sparkling pool, vibrant clubhouse, and pet-friendly spaces alongside modern floor plans featuring quartz countertops and walk-in closets. Experience a maintenance-free lifestyle in our gated community; picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to The Otis, where modern living meets vibrant community life in Macon, GA! Choose from our thoughtfully designed one, two, or three-bedroom floor plans and immerse yourself in diverse local attractions. Nearby, enjoy Amerson River Park, the Museum of Arts and Sciences, and the thrill of Urban Air Adventure Park.",
  "property_home_reviews_blurb": "At The Otis in Macon, GA, residents rave about their home: \"A welcoming community with modern amenities and a friendly atmosphere.\" Immerse yourself in a vibrant lifestyle where comfort and convenience intertwine. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At The Otis in Macon, GA, your ideal home awaits among vibrant attractions. Dive into adventure at Urban Air Trampoline Park, enjoy leisure at Amerson River Park, or immerse yourself in art at the Museum of Arts and Sciences. Check out the rich tapestry of local favorites just steps away!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Nestled in the heart of Macon, GA, The Otis redefines comfort with a variety of spacious floor plans, from one to three bedrooms. Enjoy resort-style amenities like a shimmering pool, pet-friendly parks, and a vibrant clubhouse. Experience maintenance-free living where your lifestyle flourishes—come see what makes The Otis unique!",
  "property_applynow_blurb": "Welcome to The Otis in Macon, GA, where your ideal lifestyle awaits! Choose from stylish one, two, or three-bedroom floor plans, all nestled in a gated community with fantastic amenities. Enjoy a resort-style pool, cozy clubhouse, and pet-friendly spaces while relishing the ease of maintenance-free living. Secure your dream home today!",
  "property_contactus_blurb": "At The Otis in Macon, GA, each thoughtfully designed floor plan—spanning one, two, and three bedrooms—offers a perfect blend of comfort and style. Whether you’re seeking a cozy retreat or space for the whole family, our community has it all. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "Welcome to The Otis in Macon, GA, where your perfect home awaits! Our diverse floor plans, from cozy one-bedrooms to spacious three-bedrooms, cater to every lifestyle. Curious about our vibrant community? Browse our FAQs page for insights and answers to your most pressing questions, and find your ideal living experience today!",
  "property_floorplans_blurb": "At The Otis in Macon, GA, your ideal living space awaits with thoughtfully designed one, two, and three-bedroom floor plans. Each layout harmonizes comfort and style, perfect for any lifestyle. Browse our available apartment homes today and envision your new sanctuary!",
  "property_gallery_blurb": "At The Otis in Macon, GA, vibrant living meets modern comfort. Our diverse floor plans—from one to three bedrooms—cater to every lifestyle, complemented by luxury amenities like a resort-style pool, pet-friendly dog park, and a sleek clubhouse. Picture yourself thriving in this welcoming, gated community!",
  "property_interactivemap_blurb": "Welcome to The Otis in Macon, GA, where modern living meets relaxation. Choose from spacious one, two, or three-bedroom apartments featuring sleek quartz countertops and walk-in closets. Enjoy community perks like a resort-style pool, pet-friendly amenities, and easy highway access. Uncover your perfect home using our interactive map today!",
  "property_pets_blurb": "The Otis cherishes your furry companions as much as you do, and we’re excited to welcome yours to our pet-friendly apartment community. Our thoughtfully designed homes and amenities cater not just to you but also to your pets, ensuring they feel right at home. For more details about our pet policy and how we can accommodate your beloved pet, please don’t hesitate to reach out to us.",
  "property_referafriend_blurb": "At The Otis in Macon, GA, our diverse range of one, two, and three-bedroom floor plans caters to your lifestyle. Embrace a vibrant community where great friends become fantastic neighbors! Refer a friend today and unlock the door to a welcoming home filled with shared memories and lasting connections.",
  "property_residentaccess_blurb": "Welcome to The Otis in Macon, GA, where our spacious one, two, and three-bedroom floor plans elevate your living experience. Sign in to your resident portal to effortlessly manage rent payments, schedule maintenance, and stay connected with your community. Embrace convenience—your new lifestyle awaits!",
  "property_reviews_blurb": "At The Otis in Macon, GA, residents rave about the vibrant community atmosphere, with one saying, “It's not just a place to live—it feels like home.” Intrigued? Dive into our reviews to see what our residents are saying about their extraordinary living experience!",
  "property_created_at": "1775247114886",
  "property_scheduletour_blurb": "At The Otis in Macon, GA, your ideal home awaits with thoughtfully designed one, two, and three-bedroom floor plans. Experience vibrant living in a thriving community. Curious about life here? Don't miss the chance to hear our residents' stories—schedule your tour today and envision your new beginning!",
  "property_thankyou_blurb": "Thank you for reaching out to The Otis in vibrant Macon, GA! Your interest in our thoughtfully designed one, two, and three-bedroom floor plans is appreciated. A member of our team will connect with you soon to help you find your perfect home. We can't wait to welcome you!",
  "property_virtualtours_blurb": "Welcome to The Otis in Macon, GA, where modern living meets Southern charm. Choose from stylish one, two, or three-bedroom floor plans that cater to your lifestyle. Experience the vibrant community and inviting amenities – take a virtual tour today to find your perfect home!",
  "property_copyright": "2026 All Rights Reserved. The Otis",
  "property_seo_title_home": "The Otis |  Apartments in Macon, GA",
  "property_seo_description_home": "Experience modern living at The Otis in Macon, GA! Enjoy resort-style amenities, spacious floor plans, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Macon, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at The Otis in Macon, GA! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Browse now!",
  "property_seo_title_amenities": "Amenities | Macon, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at The Otis in Macon, GA! Enjoy resort-style amenities, spacious layouts, and a pet-friendly vibe. Your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Macon, GA",
  "property_seo_description_gallery": "Discover modern living at The Otis in Macon, GA! Enjoy spacious floor plans and resort-style amenities. Explore our photo gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Otis Apartments",
  "property_seo_description_virtualtours": "Experience The Otis in Macon, GA! Take a virtual tour to explore our stunning one, two, and three-bedroom apartments tailored for your lifestyle!",
  "property_seo_title_interactivemap": "Interactive Map | The Otis Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at The Otis in Macon, GA! Choose from spacious 1-3 bedroom apartments with top-tier amenities. Check our interactive map for options!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Macon, GA",
  "property_seo_description_neighborhood": "Uncover hidden gems in Macon, GA! The Otis offers easy access to local favorites, vibrant neighborhoods, and everything you need just steps from your door.",
  "property_seo_title_contact": "Contact Us | The Otis",
  "property_seo_description_contact": "Uncover your perfect home at The Otis in Macon, GA. From cozy one-bedroom to spacious three-bedroom options, our team is ready to assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Macon, GA",
  "property_seo_description_faqs": "Find answers to your questions at The Otis in Macon, GA. From floor plans to amenities, our FAQ page has everything you need for a seamless living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Macon, GA",
  "property_seo_description_reviews": "Experience life at The Otis in Macon, GA. Delight in modern comforts, amenities, and community spirit. Check out our resident reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Macon, GA",
  "property_seo_description_applynow": "Discover modern living at The Otis in Macon, GA! Enjoy resort-style amenities, spacious layouts, and a pet-friendly community. Lease today!",
  "property_seo_title_residentaccess": "Resident Access | The Otis",
  "property_seo_description_residentaccess": "Unlock convenience at The Otis in Macon, GA! Access your resident portal for hassle-free rent payments, maintenance requests, and community updates today!",
  "property_seo_title_referafriend": "Refer A Friend | The Otis",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Otis in Macon, GA, and enjoy vibrant living together. Join our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Otis",
  "property_seo_description_scheduletour": "Step into The Otis in Macon, GA—where modern elegance meets homey comfort. Schedule a tour today and find your perfect space to thrive!",
  "property_seo_title_privacy": "Privacy Policy | The Otis",
  "property_seo_description_privacy": "At The Otis in Macon, GA, your privacy matters. Click to read our privacy policy and learn how we protect your information while you enjoy your new home.",
  "property_seo_title_accessibility": "Website Accessibility | The Otis",
  "property_seo_description_accessibility": "At The Otis in Macon, GA, we champion digital accessibility for all. Join our community where everyone can thrive without barriers. Experience inclusion today!",
  "property_seo_title_sitemap": "Sitemap | The Otis",
  "property_seo_description_sitemap": "Explore The Otis in Macon, GA! Our sitemap reveals vibrant amenities and nearby attractions—your guide to navigating your future home!",
  "property_seo_title_thankyou": "Thank You | The Otis",
  "property_seo_description_thankyou": "Thank you for reaching out to The Otis in Macon, GA! Our team is excited to connect and help you find your perfect home. Stay tuned for our reply!",
  "property_seo_title_pets": "Pet Policy | Apartments in Macon, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793479198",
  "amenities": [
    {
      "id": "custom_068d3b7c-2ac7-42d3-ab44-b4c7832c3fc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "WIFI Lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_917b4ba7-b53d-426c-9918-8858af09c213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ad0658f7-8091-4086-b286-f4387e966686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Grilling",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8ccc61a9-e491-4161-b34b-475c5614ff17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Flexpay",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23c9a34e-1604-40de-81be-c2170f5af652",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Car Care Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9fdbe48-c59f-459b-9a83-6444eaefb7e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fb526cf3-ef1f-4d6c-a32f-636ae929b328",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f7273b0-40ea-45be-88dc-c39af906dec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Community Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_700a243f-03cc-4c0b-a7a5-4ce7c0072c55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a88c2cb-da28-4a87-bce9-22708c8dfeae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7e71a24-f520-4633-8cdc-146ea39d32e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bed83fae-5a87-4f03-aecf-3a6cf4d62549",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b722988b-c019-4c90-a7ee-21cb7d1deab3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1bb78fcf-cc32-492d-88b6-d53239f8ded2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b8d22e8-20a7-4c2e-b5a3-b886cef73499",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Highway 475",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ad953734-3f5b-4335-afa6-0ea5bc9dcd9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Garages",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6baa124a-676f-4809-a9c5-406e3db4c7dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Professional Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af65ad40-ae82-4734-ac72-c090cbfcddb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Maintenance-Free Lifestyle",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc2396c7-1d2c-438a-9ebb-a626af5d6990",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Central AC/Heat",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_79fad51e-443a-4e5f-8252-737abf6ae8c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Sleek Black Appliances *",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d5a716a-0aec-4612-89ea-4e596e216875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Soaking Tubs",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05e9bbff-1ed6-42aa-9bd6-57123e711d6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Single Basin Sink *",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_37b6afcc-60d6-4f43-8d02-91474eb7a074",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cc8fa3e-d230-4be5-a73b-c8cd2a43f90d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f229729-2eeb-4248-9fe9-6d989de3945f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6de8c2bb-fa81-4558-b3b3-0156756defc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Pre Wired Security System *",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6e268765-50de-4fd3-817e-f00c661d2cdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fdd5f289-6188-4eff-9ef5-72bf92e36576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a962aae7-cea5-456f-977d-5189a085b156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony *",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83db48b7-d349-433c-9ea5-8a56e6fbf905",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cfea7dc2-d9e4-42fe-9654-f2583212fd1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops *",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a783215a-44c5-4137-a9cd-099c7d7991b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Subway Tile backsplash *",
      "amount": "false",
      "description": "Only in select apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1a10322-ce3c-460b-b8ad-3d0d25ba7acd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecb82d36-ee37-4c48-9893-b16ee036ec62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Tub and Shower Combination",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a3d3c01-9e03-4ca7-b0e5-1688339f80e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21b04659-a626-496f-a99f-50cb4c68a54a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "external_id": "false",
      "title": "Sunrooms In Select Homes",
      "amount": "false",
      "description": "Sunrooms In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0f20f802-f42a-4b4f-b39b-7440c1f28699",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-ec8b-7636-88f2-05c874f9eaef.webp",
      "image_media": {
        "alt_text": "Study area with two desks and chairs, decorated with guitars and artwork at The Otis in Macon, GA.",
        "public_id": "019e02ea-ec8b-7636-88f2-05c874f9eaef",
        "storage_key": "property/6767906449167337/019e02ea-ec8b-7636-88f2-05c874f9eaef.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a quiet study space or work from home in our well-appointed common areas. Perfect for focusing on your tasks.",
      "link": "",
      "alt_text": "Study area with two desks and chairs, decorated with guitars and artwork at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b56a811-482f-49f8-b5bb-db29b8349cee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02eb-0932-72d1-a8c2-30713cf89df7.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment complex fitness center with treadmills and weight machines at The Otis in Macon, GA.",
        "public_id": "019e02eb-0932-72d1-a8c2-30713cf89df7",
        "storage_key": "property/6767906449167337/019e02eb-0932-72d1-a8c2-30713cf89df7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring state-of-the-art cardio and strength training equipment for all your workout needs.",
      "link": "",
      "alt_text": "Interior view of a modern apartment complex fitness center with treadmills and weight machines at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6a4abe6-853a-401c-b16b-1522f6226c54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02eb-2092-737c-8d63-bbc7dbdd03e3.webp",
      "image_media": {
        "alt_text": "The Otis property sign mounted on a white brick wall at The Otis in Macon, GA.",
        "public_id": "019e02eb-2092-737c-8d63-bbc7dbdd03e3",
        "storage_key": "property/6767906449167337/019e02eb-2092-737c-8d63-bbc7dbdd03e3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome sign for The Otis apartments, featuring the property's name in bold black lettering on a natural wood-toned plank background, mounted on a clean white brick wall.",
      "link": "",
      "alt_text": "The Otis property sign mounted on a white brick wall at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39ed6fce-664d-413b-b311-0a3bf2ff1149",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02eb-25c9-738d-89d7-f3058961b357.webp",
      "image_media": {
        "alt_text": "The Otis apartment complex entrance sign with white brick pillars and wooden sign at The Otis in Macon, GA.",
        "public_id": "019e02eb-25c9-738d-89d7-f3058961b357",
        "storage_key": "property/6767906449167337/019e02eb-25c9-738d-89d7-f3058961b357.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to The Otis, where style meets comfort. This beautiful apartment community offers a premier living experience.",
      "link": "",
      "alt_text": "The Otis apartment complex entrance sign with white brick pillars and wooden sign at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ef15bb9-def6-4621-900c-18c066203aee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02eb-0ece-75c8-863a-47872de7b318.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment at The Otis in Macon, GA.",
        "public_id": "019e02eb-0ece-75c8-863a-47872de7b318",
        "storage_key": "property/6767906449167337/019e02eb-0ece-75c8-863a-47872de7b318.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8dfc4fd-4b7e-460f-a5b9-549fbd8eec6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02eb-0d6f-7319-9d50-9bba74092d74.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment at The Otis in Macon, GA.",
        "public_id": "019e02eb-0d6f-7319-9d50-9bba74092d74",
        "storage_key": "property/6767906449167337/019e02eb-0d6f-7319-9d50-9bba74092d74.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, fully equipped with cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_435096f8-d24d-4710-b35e-5d7c6f45b74b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-e710-7404-894a-0a54df7274fd.webp",
      "image_media": {
        "alt_text": "The Otis apartment building lobby with fireplace, seating areas, and entrance visible.",
        "public_id": "019e02ea-e710-7404-894a-0a54df7274fd",
        "storage_key": "property/6767906449167337/019e02ea-e710-7404-894a-0a54df7274fd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to The Otis apartment lobby, a beautifully designed community space with comfortable seating, a cozy fireplace, and a welcoming entrance.",
      "link": "",
      "alt_text": "The Otis apartment building lobby with fireplace, seating areas, and entrance visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1f88a8f-2f67-4175-8150-5b473ec5176b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02eb-029f-7668-a038-a8318f94614c.webp",
      "image_media": {
        "alt_text": "A modern conference room with a large wooden table, chairs, and a whiteboard at The Otis in Macon, GA.",
        "public_id": "019e02eb-029f-7668-a038-a8318f94614c",
        "storage_key": "property/6767906449167337/019e02eb-029f-7668-a038-a8318f94614c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Host meetings and collaborate in our stylish conference room, perfect for residents and business needs.",
      "link": "",
      "alt_text": "A modern conference room with a large wooden table, chairs, and a whiteboard at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3075fb32-e6ca-42e2-afd8-205a46196b5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02eb-00c7-70dd-b28a-933b47ab303a.webp",
      "image_media": {
        "alt_text": "Co-working space with a large table, chairs, artwork, and a TV at The Otis in Macon, GA.",
        "public_id": "019e02eb-00c7-70dd-b28a-933b47ab303a",
        "storage_key": "property/6767906449167337/019e02eb-00c7-70dd-b28a-933b47ab303a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a productive day in our co-working space, equipped with comfortable seating, a large table for collaboration, and a TV for presentations.",
      "link": "",
      "alt_text": "Co-working space with a large table, chairs, artwork, and a TV at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f7a2d607-1431-4563-8257-0fdd85eb7aed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-dd0f-733e-8821-64c33c51da3f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a Keurig coffee maker, sink, dishwasher, and mini-fridge.",
        "public_id": "019e02ea-dd0f-733e-8821-64c33c51da3f",
        "storage_key": "property/6767906449167337/019e02ea-dd0f-733e-8821-64c33c51da3f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a stylish and functional kitchen space, perfect for preparing your favorite beverages and meals. Features a Keurig, stainless steel appliances, and ample counter space.",
      "link": "",
      "alt_text": "Modern kitchen with a Keurig coffee maker, sink, dishwasher, and mini-fridge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c13acbad-1633-440a-a53d-6b0e8d7b33fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-e9ec-7667-a9f1-a82e32f34373.webp",
      "image_media": {
        "alt_text": "Modern lounge area with plush seating and artistic wall decor at The Otis in Macon, GA.",
        "public_id": "019e02ea-e9ec-7667-a9f1-a82e32f34373",
        "storage_key": "property/6767906449167337/019e02ea-e9ec-7667-a9f1-a82e32f34373.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring comfortable seating, contemporary art, and a cozy fireplace. A perfect space to socialize or enjoy a quiet moment.",
      "link": "",
      "alt_text": "Modern lounge area with plush seating and artistic wall decor at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec576787-40b4-4c98-822d-ca01df88ec2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-b4f5-7341-b5d0-309d23bd39d5.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and hangers.",
        "public_id": "019e02ea-b4f5-7341-b5d0-309d23bd39d5",
        "storage_key": "property/6767906449167337/019e02ea-b4f5-7341-b5d0-309d23bd39d5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring wire shelving and hangers, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and hangers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66de21b4-9bd6-41c1-90bc-ec51d7d250c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-e2df-748b-ae8d-258af382cb93.webp",
      "image_media": {
        "alt_text": "High-top tables and stools in a common area with large windows overlooking an outdoor patio with a grill at The Otis in Macon, GA.",
        "public_id": "019e02ea-e2df-748b-ae8d-258af382cb93",
        "storage_key": "property/6767906449167337/019e02ea-e2df-748b-ae8d-258af382cb93.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy relaxing and socializing in our stylish common areas, perfect for gathering with friends or unwinding after a long day. Features high-top tables and stools with views of the outdoor patio.",
      "link": "",
      "alt_text": "High-top tables and stools in a common area with large windows overlooking an outdoor patio with a grill at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_644271ca-7275-4436-974d-57e0da060b8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-d728-735f-b9de-665cc2102a11.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating, a large TV, and a coffee bar.",
        "public_id": "019e02ea-d728-735f-b9de-665cc2102a11",
        "storage_key": "property/6767906449167337/019e02ea-d728-735f-b9de-665cc2102a11.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring plush seating, a large entertainment screen, and a convenient coffee bar.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating, a large TV, and a coffee bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75627666-9ea5-4aa9-b22c-899fc13b662f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-bda8-72b0-b7d0-375e8766a006.webp",
      "image_media": {
        "alt_text": "Interior of a modern communal lounge with a fireplace, comfortable seating, and large windows.",
        "public_id": "019e02ea-bda8-72b0-b7d0-375e8766a006",
        "storage_key": "property/6767906449167337/019e02ea-bda8-72b0-b7d0-375e8766a006.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Step into the beautifully designed communal lounge, featuring a cozy fireplace, elegant seating arrangements, and abundant natural light pouring in through large windows.",
      "link": "",
      "alt_text": "Interior of a modern communal lounge with a fireplace, comfortable seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8ab53ee-c6c3-4c12-aa72-aac7f6cb5b11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-e25a-763a-9575-c830e61c09df.webp",
      "image_media": {
        "alt_text": "Lobby with fireplace, seating, and The Otis logo at The Otis in Macon, GA.",
        "public_id": "019e02ea-e25a-763a-9575-c830e61c09df",
        "storage_key": "property/6767906449167337/019e02ea-e25a-763a-9575-c830e61c09df.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "The modern and inviting lobby features plush seating areas, a cozy fireplace, and the property's signature logo, creating a warm and welcoming atmosphere.",
      "link": "",
      "alt_text": "Lobby with fireplace, seating, and The Otis logo at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7955853d-8f77-4d78-8dc7-152aefd47961",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-af04-7661-9f48-bc178ded5ff8.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, a dresser, and a window.",
        "public_id": "019e02ea-af04-7661-9f48-bc178ded5ff8",
        "storage_key": "property/6767906449167337/019e02ea-af04-7661-9f48-bc178ded5ff8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bedroom featuring a comfortable queen-size bed, modern nightstands, and a convenient dresser. Large windows provide ample natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, a dresser, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3fe037ac-bb16-451e-bace-f0f9447504d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-c51e-75fa-a479-f0de7fb73ab2.webp",
      "image_media": {
        "alt_text": "Interior lounge area with modern seating, fireplace, and artwork.",
        "public_id": "019e02ea-c51e-75fa-a479-f0de7fb73ab2",
        "storage_key": "property/6767906449167337/019e02ea-c51e-75fa-a479-f0de7fb73ab2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in the stylish community lounge, featuring comfortable seating, a fireplace, and contemporary decor.",
      "link": "",
      "alt_text": "Interior lounge area with modern seating, fireplace, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b0e2801-5324-4f63-b534-fab8db1dc0c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-ae3b-7489-909e-cc65aba662d5.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with island, black appliances, and white cabinetry.",
        "public_id": "019e02ea-ae3b-7489-909e-cc65aba662d5",
        "storage_key": "property/6767906449167337/019e02ea-ae3b-7489-909e-cc65aba662d5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this modern apartment kitchen, featuring an island, ample cabinet space, and a dedicated dining area.",
      "link": "",
      "alt_text": "Dining area and kitchen with island, black appliances, and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cdc8e5e5-1ac0-4ba2-a810-c48e2d5c3ed6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-a9d2-719b-84d7-2cadc44bb9bf.webp",
      "image_media": {
        "alt_text": "A home office setup with a white desk, two chairs, a potted plant, and a sliding glass door with blinds.",
        "public_id": "019e02ea-a9d2-719b-84d7-2cadc44bb9bf",
        "storage_key": "property/6767906449167337/019e02ea-a9d2-719b-84d7-2cadc44bb9bf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this apartment's dedicated home office area. Featuring a stylish desk, comfortable seating, and ample natural light, it's perfect for productivity.",
      "link": "",
      "alt_text": "A home office setup with a white desk, two chairs, a potted plant, and a sliding glass door with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d6eebb2-cb05-4959-ab79-34ee0b36572c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-7902-75a4-a4b3-6b7f081707ee.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and a large island.",
        "public_id": "019e02ea-7902-75a4-a4b3-6b7f081707ee",
        "storage_key": "property/6767906449167337/019e02ea-7902-75a4-a4b3-6b7f081707ee.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, sleek black appliances, and a large island with a sink. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5900cae0-d6ea-4cb4-8ef3-f6d2f1246e85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-bd01-7728-9854-af10c7e56d69.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, black faucet, and large black framed mirror.",
        "public_id": "019e02ea-bd01-7728-9854-af10c7e56d69",
        "storage_key": "property/6767906449167337/019e02ea-bd01-7728-9854-af10c7e56d69.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Stylish and functional bathroom featuring a spacious vanity with ample counter space and a large mirror, perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, sink, black faucet, and large black framed mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_231fd85b-2afe-4c49-b10d-8479d58f5e5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-a84f-73ac-a22f-60fdf1694761.webp",
      "image_media": {
        "alt_text": "Living room with a green sofa, coffee table, TV, and a ceiling fan.",
        "public_id": "019e02ea-a84f-73ac-a22f-60fdf1694761",
        "storage_key": "property/6767906449167337/019e02ea-a84f-73ac-a22f-60fdf1694761.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush green sofa, a modern coffee table, and an entertainment center with a flat-screen TV. A ceiling fan overhead provides comfort.",
      "link": "",
      "alt_text": "Living room with a green sofa, coffee table, TV, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b48303f9-ae5d-4f56-bd63-fd11d64a1c2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-b6a0-734f-ab19-8b034cbdad58.webp",
      "image_media": {
        "alt_text": "King-size bed with white bedding and decorative pillows in a bright bedroom with wood dresser and accent chair at The Otis in Macon, GA.",
        "public_id": "019e02ea-b6a0-734f-ab19-8b034cbdad58",
        "storage_key": "property/6767906449167337/019e02ea-b6a0-734f-ab19-8b034cbdad58.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, stylish decor, and ample natural light. Perfect for relaxation.",
      "link": "",
      "alt_text": "King-size bed with white bedding and decorative pillows in a bright bedroom with wood dresser and accent chair at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_108d7bbf-a427-4c7c-ac80-e2d475790a98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-7651-728c-b05b-63094558dbef.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, blue accents, and a large window.",
        "public_id": "019e02ea-7651-728c-b05b-63094558dbef",
        "storage_key": "property/6767906449167337/019e02ea-7651-728c-b05b-63094558dbef.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bedroom, featuring a comfortable queen-size bed, stylish decor, and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, blue accents, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75eff333-1e6b-4a7c-9bd3-1c620f024e03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-77bc-758b-8320-431235d9d888.webp",
      "image_media": {
        "alt_text": "Modern black faucet over a white countertop with a living area in the background at The Otis in Macon, GA.",
        "public_id": "019e02ea-77bc-758b-8320-431235d9d888",
        "storage_key": "property/6767906449167337/019e02ea-77bc-758b-8320-431235d9d888.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy the sleek design of your new apartment kitchen, featuring a contemporary black faucet and spacious countertop. The open-concept living area provides a comfortable space for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern black faucet over a white countertop with a living area in the background at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f7e2ea68-716f-41af-9a9f-41d4fd2fc7bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-5d37-701e-81ec-5c10740a0cc3.webp",
      "image_media": {
        "alt_text": "A modern dining area with a round table set for four and a light wood sideboard.",
        "public_id": "019e02ea-5d37-701e-81ec-5c10740a0cc3",
        "storage_key": "property/6767906449167337/019e02ea-5d37-701e-81ec-5c10740a0cc3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish dining space featuring a round table with place settings, complemented by a sleek sideboard and modern art on the wall.",
      "link": "",
      "alt_text": "A modern dining area with a round table set for four and a light wood sideboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ed0cde0-4f9a-4f2f-a897-6061e5f06a4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-5a81-76f2-9097-5747e55c8601.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and a large island with a sink.",
        "public_id": "019e02ea-5a81-76f2-9097-5747e55c8601",
        "storage_key": "property/6767906449167337/019e02ea-5a81-76f2-9097-5747e55c8601.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, sleek black appliances, and a convenient island with a sink, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and a large island with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d98f91d-26ab-4410-aa65-0d58ecbe9663",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-78e8-722e-8aa4-84ded330d0ff.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a large bed, dresser, and closet at The Otis in Macon, GA.",
        "public_id": "019e02ea-78e8-722e-8aa4-84ded330d0ff",
        "storage_key": "property/6767906449167337/019e02ea-78e8-722e-8aa4-84ded330d0ff.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bedroom, featuring a plush queen-size bed, a chic dresser, and ample closet space for all your storage needs. Comfort and style await.",
      "link": "",
      "alt_text": "Stylish bedroom with a large bed, dresser, and closet at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_58cdb251-1186-4c2c-9814-e62cc9c84f05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-5d37-701e-81ec-62772e3b394c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and grey subway tile backsplash.",
        "public_id": "019e02ea-5d37-701e-81ec-62772e3b394c",
        "storage_key": "property/6767906449167337/019e02ea-5d37-701e-81ec-62772e3b394c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring white cabinetry, a full suite of black appliances including a refrigerator and oven, and a grey subway tile backsplash, with a convenient pantry visible.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and grey subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f795b111-d439-407c-90ec-f949106e6341",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-5cd4-74fd-b9e1-207dd1d4da66.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and a large island with a sink.",
        "public_id": "019e02ea-5cd4-74fd-b9e1-207dd1d4da66",
        "storage_key": "property/6767906449167337/019e02ea-5cd4-74fd-b9e1-207dd1d4da66.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, a full suite of black appliances including a refrigerator and stove, and a central island with a sink, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, and a large island with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6396a19d-fa8a-43c1-a5be-2b35e650c3a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-5b5d-701c-b1ce-299b58b07439.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, black fixtures, and a bathtub with shower curtain.",
        "public_id": "019e02ea-5b5d-701c-b1ce-299b58b07439",
        "storage_key": "property/6767906449167337/019e02ea-5b5d-701c-b1ce-299b58b07439.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this modern apartment bathroom, featuring a sleek vanity, updated fixtures, and a clean, inviting bathtub area.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, black fixtures, and a bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_07fcb29d-ef99-4ebf-bc02-7e41942ef31d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-5f50-7575-b0b2-68c891b6a897.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with beige siding and black shutters on a sunny day.",
        "public_id": "019e02ea-5f50-7575-b0b2-68c891b6a897",
        "storage_key": "property/6767906449167337/019e02ea-5f50-7575-b0b2-68c891b6a897.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building, showcasing its beige siding, black shutters, and well-maintained landscaping. Offers a welcoming facade with a clear blue sky overhead.",
      "link": "",
      "alt_text": "Exterior view of apartment building with beige siding and black shutters on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f22d01f3-b39a-43cf-800c-fdf4e845ea45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7904-4e12-7210-8f28-c9227c161193.webp",
      "image_media": {
        "alt_text": "Outdoor play area with a track for toy cars, surrounded by fencing and trees.",
        "public_id": "019d7904-4e12-7210-8f28-c9227c161193",
        "storage_key": "property/6767906449167337/019d7904-4e12-7210-8f28-c9227c161193.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "This is a fun outdoor play area designed to resemble a miniature road system, perfect for children's entertainment within the community.",
      "link": "",
      "alt_text": "Outdoor play area with a track for toy cars, surrounded by fencing and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4a36e10d-0919-4b44-9dd6-35fe483cc446",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7904-4d40-713c-ac01-0ba9dcdec196.webp",
      "image_media": {
        "alt_text": "Kids' play area with miniature roads and toy cars.",
        "public_id": "019d7904-4d40-713c-ac01-0ba9dcdec196",
        "storage_key": "property/6767906449167337/019d7904-4d40-713c-ac01-0ba9dcdec196.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "This fun and safe play area features miniature roads and colorful toy cars for children to enjoy.",
      "link": "",
      "alt_text": "Kids' play area with miniature roads and toy cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31712769-d69f-4d91-b553-18ad7c3e9d2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7904-59d2-73cf-b5c9-05c2642f033b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, white countertops, black refrigerator, and black oven.",
        "public_id": "019d7904-59d2-73cf-b5c9-05c2642f033b",
        "storage_key": "property/6767906449167337/019d7904-59d2-73cf-b5c9-05c2642f033b.webp",
        "width": 1600,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Experience a functional and stylish kitchen with sleek white cabinetry, durable white countertops, a black refrigerator, and a black oven, perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, white countertops, black refrigerator, and black oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_04fc06b2-2454-4071-bb34-5c24b6aafa21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7904-587b-7541-8e11-ae59887d1dff.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and faucet, leading to a hallway with a doorway at The Otis in Macon, GA.",
        "public_id": "019d7904-587b-7541-8e11-ae59887d1dff",
        "storage_key": "property/6767906449167337/019d7904-587b-7541-8e11-ae59887d1dff.webp",
        "width": 1200,
        "height": 1600
      },
      "title": "Apartment",
      "description": "A modern kitchen island with a black sink and faucet, adjacent to a hallway that opens into another room. This image showcases the interior design and flow of the apartment.",
      "link": "",
      "alt_text": "Kitchen island with sink and faucet, leading to a hallway with a doorway at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10d9ed31-a8c5-4228-992c-1486e86f89ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7904-4c6b-7162-a2f8-b3c82e01cc1d.webp",
      "image_media": {
        "alt_text": "Outdoor play area designed like a miniature road system with toy cars and a scooter, providing a fun space for children.",
        "public_id": "019d7904-4c6b-7162-a2f8-b3c82e01cc1d",
        "storage_key": "property/6767906449167337/019d7904-4c6b-7162-a2f8-b3c82e01cc1d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "A unique outdoor play area featuring a miniature road system, complete with street markings and toy vehicles, offering a safe and imaginative space for children to play and explore within the community.",
      "link": "",
      "alt_text": "Outdoor play area designed like a miniature road system with toy cars and a scooter, providing a fun space for children.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d56721ad-814d-4278-bbf1-5acf320e7c06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7904-4bb4-741f-98c5-a00117f3d8df.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washers and dryers, seating area, and folding counter at The Otis in Macon, GA.",
        "public_id": "019d7904-4bb4-741f-98c5-a00117f3d8df",
        "storage_key": "property/6767906449167337/019d7904-4bb4-741f-98c5-a00117f3d8df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient laundry facilities available for residents, featuring multiple washers and dryers, a folding counter, and comfortable seating.",
      "link": "",
      "alt_text": "Laundry room with stacked washers and dryers, seating area, and folding counter at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13517786-5eea-4f8a-b9af-8330381cdc78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-8b5a-770e-964d-9d81effcfcb5.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by green lawns and trees at The Otis in Macon, GA.",
        "public_id": "019d7903-8b5a-770e-964d-9d81effcfcb5",
        "storage_key": "property/6767906449167337/019d7903-8b5a-770e-964d-9d81effcfcb5.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Spacious apartment buildings set amidst lush greenery, offering a serene and comfortable living environment. This aerial perspective showcases the property's beautiful grounds and architecture.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounded by green lawns and trees at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b024e07-53f3-4607-a2f6-a4583459071b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-8bd4-769e-ba1f-013139b223c1.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with multiple buildings, a pool, tennis court, and volleyball court.",
        "public_id": "019d7903-8bd4-769e-ba1f-013139b223c1",
        "storage_key": "property/6767906449167337/019d7903-8bd4-769e-ba1f-013139b223c1.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Spacious apartment complex featuring modern buildings, a refreshing pool, recreational courts, and lush landscaping, offering a vibrant community atmosphere.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with multiple buildings, a pool, tennis court, and volleyball court.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_338ff96d-5816-4948-8d0b-fc1969128b51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-819d-70ae-8d01-e850b58c5229.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with parking lots and trees.",
        "public_id": "019d7903-819d-70ae-8d01-e850b58c5229",
        "storage_key": "property/6767906449167337/019d7903-819d-70ae-8d01-e850b58c5229.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing apartment buildings, well-maintained parking areas, and lush green landscaping, offering a glimpse into the community's serene environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with parking lots and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10f1fbbb-bdb9-4762-8162-818572131c25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-7c00-770f-9e6b-c8f837b612c2.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, including a tunnel, ramp, and weave poles.",
        "public_id": "019d7903-7c00-770f-9e6b-c8f837b612c2",
        "storage_key": "property/6767906449167337/019d7903-7c00-770f-9e6b-c8f837b612c2.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, perfect for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "Dog park with agility equipment, including a tunnel, ramp, and weave poles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_767babfe-ceb5-4f16-a8fb-0d21622e518d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-8aab-70be-a007-641b686e0e6a.webp",
      "image_media": {
        "alt_text": "Building exterior with a clear blue sky.",
        "public_id": "019d7903-8aab-70be-a007-641b686e0e6a",
        "storage_key": "property/6767906449167337/019d7903-8aab-70be-a007-641b686e0e6a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "The exterior of the community building, featuring a leasing center, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Building exterior with a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_befc9592-4fe1-4172-8b54-385c03f0cdbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-9480-748d-a263-17264e5af121.webp",
      "image_media": {
        "alt_text": "Aerial view of a historic cityscape with various buildings and a prominent church steeple.",
        "public_id": "019d7903-9480-748d-a263-17264e5af121",
        "storage_key": "property/6767906449167337/019d7903-9480-748d-a263-17264e5af121.webp",
        "width": 1800,
        "height": 1201
      },
      "title": "Community",
      "description": "Explore the charm of this historic city, featuring a diverse range of architectural styles and a picturesque landscape.",
      "link": "",
      "alt_text": "Aerial view of a historic cityscape with various buildings and a prominent church steeple.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e808bbd9-a046-41ac-9eca-1947de562835",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-7be4-73c9-8228-cdba25f645ea.webp",
      "image_media": {
        "alt_text": "Aerial view of a fenced dog park with agility equipment at The Otis in Macon, GA.",
        "public_id": "019d7903-7be4-73c9-8228-cdba25f645ea",
        "storage_key": "property/6767906449167337/019d7903-7be4-73c9-8228-cdba25f645ea.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our community dog park, featuring agility equipment for your furry friends to play and explore. A perfect space for pets to socialize and exercise.",
      "link": "",
      "alt_text": "Aerial view of a fenced dog park with agility equipment at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d463a108-f8e7-4cdb-9cb3-a1dde64cdcac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-7342-7159-bfea-8c231815378d.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with beige siding, black shutters, and a dark roof.",
        "public_id": "019d7903-7342-7159-bfea-8c231815378d",
        "storage_key": "property/6767906449167337/019d7903-7342-7159-bfea-8c231815378d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Beautifully maintained apartment building exterior with manicured landscaping, showcasing a welcoming facade and ample green space.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with beige siding, black shutters, and a dark roof.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9984ccb5-e680-4ab4-8581-2ef3b06b90c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-781e-7248-8aef-c5d0e15f336a.webp",
      "image_media": {
        "alt_text": "Exterior view of a tan apartment building with black shutters and a balcony.",
        "public_id": "019d7903-781e-7248-8aef-c5d0e15f336a",
        "storage_key": "property/6767906449167337/019d7903-781e-7248-8aef-c5d0e15f336a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "The exterior of a charming apartment building, featuring classic tan siding, well-maintained landscaping, and private balconies.",
      "link": "",
      "alt_text": "Exterior view of a tan apartment building with black shutters and a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_14a3ee2a-6fd8-4565-9207-5f794376e90d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-6f21-7209-84ec-c2d309424243.webp",
      "image_media": {
        "alt_text": "Volleyball court and playground area at apartment complex at The Otis in Macon, GA.",
        "public_id": "019d7903-6f21-7209-84ec-c2d309424243",
        "storage_key": "property/6767906449167337/019d7903-6f21-7209-84ec-c2d309424243.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy recreational activities at our apartment complex, featuring a sand volleyball court and a children's playground. Perfect for active living.",
      "link": "",
      "alt_text": "Volleyball court and playground area at apartment complex at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_476b575d-549e-4484-bcb9-b2a8230e4be6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-5e4f-75f9-9fde-15633efd1d0c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and grilling area.",
        "public_id": "019d7903-5e4f-75f9-9fde-15633efd1d0c",
        "storage_key": "property/6767906449167337/019d7903-5e4f-75f9-9fde-15633efd1d0c.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the community pool, perfect for relaxing or entertaining guests. Features lounge chairs and outdoor grills.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and grilling area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_69dea0e9-6b3f-4c1a-bafc-6c1d9984100c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-6528-76dd-a18f-d5a0bc62e411.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and sports court with surrounding trees  at The Otis in Macon, GA.",
        "public_id": "019d7903-6528-76dd-a18f-d5a0bc62e411",
        "storage_key": "property/6767906449167337/019d7903-6528-76dd-a18f-d5a0bc62e411.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or engage in some friendly competition on the sports court. Perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Resort-style swimming pool and sports court with surrounding trees  at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cedfa3ac-494d-46a8-be55-e87589b944c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-5d1c-75da-a410-a719517795ca.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating areas, next to a building.",
        "public_id": "019d7903-5d1c-75da-a410-a719517795ca",
        "storage_key": "property/6767906449167337/019d7903-5d1c-75da-a410-a719517795ca.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating areas, next to a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4f92ee7-6786-4974-95a5-7eee57bdf326",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-60f8-76ff-9877-8b4d6ac92586.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool area with lounge chairs and tables.",
        "public_id": "019d7903-60f8-76ff-9877-8b4d6ac92586",
        "storage_key": "property/6767906449167337/019d7903-60f8-76ff-9877-8b4d6ac92586.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and tables for ultimate relaxation.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool area with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_14211d3d-80d0-41ab-bd20-67a2b1914e57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-64db-7498-b7aa-ff307b761e3b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and grilling area with pergolas and seating at The Otis in Macon, GA.",
        "public_id": "019d7903-64db-7498-b7aa-ff307b761e3b",
        "storage_key": "property/6767906449167337/019d7903-64db-7498-b7aa-ff307b761e3b.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining by the pool with our community grilling stations and shaded pergolas.",
      "link": "",
      "alt_text": "Outdoor swimming pool and grilling area with pergolas and seating at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5de1abf5-4428-4321-bb5d-a5b368ece08b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-524d-76aa-9c6e-e590a6a10e81.webp",
      "image_media": {
        "alt_text": "Outdoor play area with a road and circular design for children's activities at The Otis in Macon, GA.",
        "public_id": "019d7903-524d-76aa-9c6e-e590a6a10e81",
        "storage_key": "property/6767906449167337/019d7903-524d-76aa-9c6e-e590a6a10e81.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Engage in fun and games on our unique outdoor play area, designed for imaginative adventures.",
      "link": "",
      "alt_text": "Outdoor play area with a road and circular design for children's activities at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb5d15cb-a526-45fa-8996-6b7158dbc94a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-577a-7725-ae04-962e21cde726.webp",
      "image_media": {
        "alt_text": "Colorful community court with road markings and circular play areas at The Otis in Macon, GA.",
        "public_id": "019d7903-577a-7725-ae04-962e21cde726",
        "storage_key": "property/6767906449167337/019d7903-577a-7725-ae04-962e21cde726.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our unique community court, perfect for recreation and fun.",
      "link": "",
      "alt_text": "Colorful community court with road markings and circular play areas at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0b81625c-f7df-431b-afb5-fbf67eff6a1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-43ea-71c9-a015-958e42d5e286.webp",
      "image_media": {
        "alt_text": "Community building exterior with manicured landscaping and parking lot at The Otis in Macon, GA.",
        "public_id": "019d7903-43ea-71c9-a015-958e42d5e286",
        "storage_key": "property/6767906449167337/019d7903-43ea-71c9-a015-958e42d5e286.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "View of the apartment community's main building exterior, showcasing well-maintained grounds and entrance.",
      "link": "",
      "alt_text": "Community building exterior with manicured landscaping and parking lot at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_07349919-887a-4d0b-90d1-1b5bb0bb7557",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-43e8-73df-8571-695d41b36450.webp",
      "image_media": {
        "alt_text": "Leasing center building with a manicured lawn and landscaping, under a clear blue sky at The Otis in Macon, GA.",
        "public_id": "019d7903-43e8-73df-8571-695d41b36450",
        "storage_key": "property/6767906449167337/019d7903-43e8-73df-8571-695d41b36450.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Visit our leasing center to learn more about our community and available floor plans. Enjoy the beautiful exterior and welcoming atmosphere.",
      "link": "",
      "alt_text": "Leasing center building with a manicured lawn and landscaping, under a clear blue sky at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a578f5f3-7e97-46fd-97fc-bae9711918fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-43ff-74ef-865d-e50517b96425.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pools and sports courts at The Otis in Macon, GA.",
        "public_id": "019d7903-43ff-74ef-865d-e50517b96425",
        "storage_key": "property/6767906449167337/019d7903-43ff-74ef-865d-e50517b96425.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Spacious apartment community featuring multiple pools, sports courts, and lush green spaces. Enjoy an active lifestyle in this serene setting.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with pools and sports courts at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0c37c88-781d-42a9-9330-3ee4b6e60a51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-43b0-765c-b724-a3908723cfd0.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool, volleyball court, and sports court  at The Otis in Macon, GA.",
        "public_id": "019d7903-43b0-765c-b724-a3908723cfd0",
        "storage_key": "property/6767906449167337/019d7903-43b0-765c-b724-a3908723cfd0.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our sparkling swimming pool, sand volleyball court, and versatile sports court. Perfect for recreation and relaxation.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool, volleyball court, and sports court  at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9e1b4205-c83f-4d5c-a4b9-2c91fac8ea01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-41cf-776d-9cfb-aec89c682926.webp",
      "image_media": {
        "alt_text": "Exterior view of the leasing office building with manicured bushes and parking lot  at The Otis in Macon, GA.",
        "public_id": "019d7903-41cf-776d-9cfb-aec89c682926",
        "storage_key": "property/6767906449167337/019d7903-41cf-776d-9cfb-aec89c682926.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Welcome to the leasing office, your first stop to discover your new home. Tour our amenities and find the perfect floor plan for you.",
      "link": "",
      "alt_text": "Exterior view of the leasing office building with manicured bushes and parking lot  at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_65d4907e-9261-4f55-9ec1-597552ed9161",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-444f-74da-8024-70ad0a674a35.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet, ceiling fan, and window with blinds at The Otis in Macon, GA.",
        "public_id": "019d7903-444f-74da-8024-70ad0a674a35",
        "storage_key": "property/6767906449167337/019d7903-444f-74da-8024-70ad0a674a35.webp",
        "width": 1200,
        "height": 1600
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring plush carpeting, a modern ceiling fan, and a large window that allows natural light to fill the room.",
      "link": "",
      "alt_text": "Bedroom with carpet, ceiling fan, and window with blinds at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_523d17ec-423e-413f-abb4-bfc24204fc8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-438c-73cf-a7cc-c236c99d1f71.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with swimming pool, tennis courts, and beach volleyball  at The Otis in Macon, GA.",
        "public_id": "019d7903-438c-73cf-a7cc-c236c99d1f71",
        "storage_key": "property/6767906449167337/019d7903-438c-73cf-a7cc-c236c99d1f71.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Spacious apartment community featuring a swimming pool, tennis courts, and beach volleyball area, surrounded by lush greenery and mature trees. Enjoy outdoor recreation and a serene environment.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with swimming pool, tennis courts, and beach volleyball  at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d4cc0001-dd1b-4d46-a30d-633442897d0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-41e1-7100-9af9-bfde5daf17a3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, black hardware, and wood-look flooring at The Otis in Macon, GA.",
        "public_id": "019d7903-41e1-7100-9af9-bfde5daf17a3",
        "storage_key": "property/6767906449167337/019d7903-41e1-7100-9af9-bfde5daf17a3.webp",
        "width": 1200,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Step into a clean and contemporary bathroom featuring a sleek white vanity with ample storage, modern black fixtures, and stylish wood-look flooring. Perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, black hardware, and wood-look flooring at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_68103b38-dc5a-4f45-93a7-706cb5b17739",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d7903-4142-7777-afc9-3756996ebe77.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, toilet, and bathtub with black fixtures  at The Otis in Macon, GA.",
        "public_id": "019d7903-4142-7777-afc9-3756996ebe77",
        "storage_key": "property/6767906449167337/019d7903-4142-7777-afc9-3756996ebe77.webp",
        "width": 1200,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this modern bathroom featuring a spacious vanity, a clean white toilet, and a pristine bathtub with elegant black fixtures.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, toilet, and bathtub with black fixtures  at The Otis in Macon, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_eb307494-2367-4703-a64f-b9c290ecff7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5080 Riverside Dr Suite 1500, Macon, GA 31210, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves perfectly cooked steak, ribs, and salmon. They also highlight the friendly and attentive service, and the fun, lively atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-643d-7419-a559-7793bf12e858.webp",
      "poi_featured_image_media": {
        "alt_text": "Texas Road House restaurant exterior with a parking lot and accessible parking spaces.",
        "public_id": "019d54f9-643d-7419-a559-7793bf12e858",
        "storage_key": "property/6767906449167337/019d54f9-643d-7419-a559-7793bf12e858.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/georgia/macon?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7708744444521463649&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.9245606",
      "poi_longitude": "-83.71236239999999",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 478-477-3777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f9-dfba-72aa-a54e-479624a241d7",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRYb_3xzr2-mo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_44dfabbf-dd3c-4789-97c2-7f3e4acc4bc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "4704 Presidential Pkwy, Macon, GA 31206, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of family favorites, including steak, ribs, and a salad bar. They also highlight the friendly and attentive service, and the clean and well-lit atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-563c-7242-b163-abb9c1fb69b2.webp",
      "poi_featured_image_media": {
        "alt_text": "Golden Corral restaurant exterior at dusk with lit signage and people entering.",
        "public_id": "019d54f9-563c-7242-b163-abb9c1fb69b2",
        "storage_key": "property/6767906449167337/019d54f9-563c-7242-b163-abb9c1fb69b2.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/2554/golden-corral-presidential-pkwy?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2554",
      "poi_directions_map_url": "https://maps.google.com/?cid=1206382079797030989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "32.8146875",
      "poi_longitude": "-83.7179213",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-757-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f9-dfba-72aa-a54e-479624a241d7",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Xuljsz784gRTfCyIRzuvRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_008fd189-5ea1-4c4b-b364-f9f77f0772a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "140 Tom Hill Sr Blvd, Macon, GA 31210, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Diners say this chicken restaurant offers delicious chicken, fresh hot food, and a variety of sauces. They also highlight the friendly and efficient staff, and the clean dining room and restrooms.\n\nSome reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-58e6-7276-bc8c-2a52aa37c38d.webp",
      "poi_featured_image_media": {
        "alt_text": "Chick-fil-A restaurant exterior with outdoor seating area and red umbrellas.",
        "public_id": "019d54f9-58e6-7276-bc8c-2a52aa37c38d",
        "storage_key": "property/6767906449167337/019d54f9-58e6-7276-bc8c-2a52aa37c38d.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/tom-hill-sr-blvd?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3042950987368538044&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.9002864",
      "poi_longitude": "-83.6886184",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 478-471-0274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f9-dfba-72aa-a54e-479624a241d7",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZuiK7j484gRvJ8G_8y7Oio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1df27161-0278-4da0-ba10-8a268c6142e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "3950 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Diners say this American restaurant serves up delicious chicken and dumplings, meatloaf, mashed potatoes, and biscuits and gravy. They also highlight the friendly and attentive service, reasonable prices, and clean atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-55c5-7176-9376-38bb54bb5e8a.webp",
      "poi_featured_image_media": {
        "alt_text": "Cracker Barrel Old Country Store exterior with rocking chairs and flowers.",
        "public_id": "019d54f9-55c5-7176-9376-38bb54bb5e8a",
        "storage_key": "property/6767906449167337/019d54f9-55c5-7176-9376-38bb54bb5e8a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ga/macon/46/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=37612520828105272&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "32.9038498",
      "poi_longitude": "-83.68972839999999",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 478-474-7029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f9-dfba-72aa-a54e-479624a241d7",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wsbO7r484gROPIQb2OghQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f1490ef5-c7c7-49f0-ab67-2dfa70156b0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "3710 Northside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Diners say this American restaurant serves up delicious smash burgers, cheese curds, and custard, especially the chocolate and peanut butter flavors. They also highlight the fresh food, reasonable prices, and friendly customer service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-6444-736d-ad1d-10b9e3eb488a.webp",
      "poi_featured_image_media": {
        "alt_text": "Culver's restaurant building exterior with signage and drive-thru menu.",
        "public_id": "019d54f9-6444-736d-ad1d-10b9e3eb488a",
        "storage_key": "property/6767906449167337/019d54f9-6444-736d-ad1d-10b9e3eb488a.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.culvers.com/restaurants/macon-ga-northside-dr/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=7331129185597483569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "32.8962811",
      "poi_longitude": "-83.6909743",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 478-305-7093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f9-dfba-72aa-a54e-479624a241d7",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSo0Zhv584gRMWoJ_iZnvWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f3675888-2e03-44a1-aa82-8981129af593",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "The Shoppes at River Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "5080 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Strip mall featuring a variety of dining & shopping options, from electronics to shoes.",
      "poi_long_description": "People say this shopping center has a great selection of popular stores and restaurants, and they appreciate that it's clean and well-maintained. They also highlight the friendly atmosphere and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-56e6-764f-bf8b-108d416cfc87.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a strip mall with stores like Yankee Candle and Zales, under a blue sky.",
        "public_id": "019d54f9-56e6-764f-bf8b-108d416cfc87",
        "storage_key": "property/6767906449167337/019d54f9-56e6-764f-bf8b-108d416cfc87.webp",
        "width": 2880,
        "height": 1147
      },
      "poi_business_url": "https://www.theshoppesatrivercrossing.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6541699009911410211&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shoppes-at-river-crossing",
      "poi_latitude": "32.9267397",
      "poi_longitude": "-83.7152815",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 478-254-2941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-4a1d06d6cb4d.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54f9-dfba-72aa-a54e-4a1d06d6cb4d",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-4a1d06d6cb4d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRI05LEZfIyFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_bc5fe1e7-359b-487c-a5e1-f5a8a42f82db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4635 Presidential Pkwy, Macon, GA 31206, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and has helpful staff. They also highlight the friendly and knowledgeable service, and the quick checkout.\n\nOther reviews mention the store can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-55c4-718b-a857-7d0b8a217f94.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot store exterior with entrance and landscaping",
        "public_id": "019d54f9-55c4-718b-a857-7d0b8a217f94",
        "storage_key": "property/6767906449167337/019d54f9-55c4-718b-a857-7d0b8a217f94.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/W-Macon/GA/Macon/31206/1772?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2763609933742180281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "32.8226858",
      "poi_longitude": "-83.71339060000001",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-477-0266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-4a1d06d6cb4d.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54f9-dfba-72aa-a54e-4a1d06d6cb4d",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-4a1d06d6cb4d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgz465NH784gRuYdxrpdQWiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_7c2f4dbf-bead-496b-bca4-5d5009ff37f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Publix Super Market at Bass Plantation",
      "poi_type": "Shopping & Retail",
      "poi_address": "5451 Bowman Rd, Macon, GA 31210, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and baked goods, as well as a deli with subs, fried chicken, and ready-made meals. They highlight the clean and well-stocked store, and the friendly and helpful staff. They also like the BOGO specials and the convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-5702-7506-bb55-d0799ffdc4ec.webp",
      "poi_featured_image_media": {
        "alt_text": "Publix Food & Pharmacy store exterior with prominent signage.",
        "public_id": "019d54f9-5702-7506-bb55-d0799ffdc4ec",
        "storage_key": "property/6767906449167337/019d54f9-5702-7506-bb55-d0799ffdc4ec.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1263&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=11892024531365352692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-bass-plantation",
      "poi_latitude": "32.9244238",
      "poi_longitude": "-83.7355869",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-474-3064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfc7-72f9-806f-52b6d33cf257.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f9-dfc7-72f9-806f-52b6d33cf257",
        "storage_key": "property/6767906449167337/019d54f9-dfc7-72f9-806f-52b6d33cf257.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXZagIkH9IgR9FRD_E31CKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_069a6300-3c09-4c11-8401-521677ecae44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Publix Super Market at Tobesofkee Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "5581 Thomaston Rd, Macon, GA 31220, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a great selection of quality foods, a good deli, and delicious sandwiches and subs. They also highlight the friendly and helpful staff, the clean and well-organized store, and the convenient pick-up and go lunch options.\n\nOther reviews mention the deli can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-588a-7140-85ee-0dd1e5e8a6f4.webp",
      "poi_featured_image_media": {
        "alt_text": "Publix Food & Pharmacy store exterior with parking lot and handicap signs.",
        "public_id": "019d54f9-588a-7140-85ee-0dd1e5e8a6f4",
        "storage_key": "property/6767906449167337/019d54f9-588a-7140-85ee-0dd1e5e8a6f4.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1700&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=16757949159435811531&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-tobesofkee-crossing",
      "poi_latitude": "32.8358575",
      "poi_longitude": "-83.74385339999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-474-4918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfc7-72f9-806f-52b6d33cf257.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f9-dfc7-72f9-806f-52b6d33cf257",
        "storage_key": "property/6767906449167337/019d54f9-dfc7-72f9-806f-52b6d33cf257.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-jC563584gRyzo6HPkxkOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_2c7509d6-dda6-419c-9d16-6a30b403358e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "6011 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide selection of products. They also highlight the helpful staff.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-55ba-717e-a8bb-2a6639b43cb0.webp",
      "poi_featured_image_media": {
        "alt_text": "Lowe's logo on a blue brick building.",
        "public_id": "019d54f9-55ba-717e-a8bb-2a6639b43cb0",
        "storage_key": "property/6767906449167337/019d54f9-55ba-717e-a8bb-2a6639b43cb0.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/GA-Macon/1016?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1016-_-na-_-0-_-0&y_source=1_MTE4MzM4MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10022872471763724290&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.88092",
      "poi_longitude": "-83.76259",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-405-7432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-4a1d06d6cb4d.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54f9-dfba-72aa-a54e-4a1d06d6cb4d",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-4a1d06d6cb4d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_1IDeYD384gRAqiE3GhlGIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_fe303649-eccc-4b5d-b79e-b6886a890d8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Mercer University",
      "poi_type": "Education",
      "poi_address": "1501 Mercer University Dr, Macon, GA 31207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-71fa-700c-af6e-4a09d6e10cd2.webp",
      "poi_featured_image_media": {
        "alt_text": "Historic brick building with spires and tall windows, surrounded by mature trees and a grassy lawn.",
        "public_id": "019d54f9-71fa-700c-af6e-4a09d6e10cd2",
        "storage_key": "property/6767906449167337/019d54f9-71fa-700c-af6e-4a09d6e10cd2.webp",
        "width": 2048,
        "height": 1152
      },
      "poi_business_url": "http://www.mercer.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11661349141602039264&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercer-university",
      "poi_latitude": "32.8284878",
      "poi_longitude": "-83.64969909999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-637-2378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f9-dfa1-726c-80e1-affa43220428",
        "storage_key": "property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS4T9n4n-84gR4PX-gkJv1aE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b7e70990-3634-4c45-b779-96852024421a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Middle Georgia State University - Macon Campus",
      "poi_type": "Education",
      "poi_address": "100 University Pkwy, Macon, GA 31206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-712d-77db-9979-dfb5b5e14ddf.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern office buildings reflected in a lake with a fountain.",
        "public_id": "019d54f9-712d-77db-9979-dfb5b5e14ddf",
        "storage_key": "property/6767906449167337/019d54f9-712d-77db-9979-dfb5b5e14ddf.webp",
        "width": 600,
        "height": 337
      },
      "poi_business_url": "https://www.mga.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021359213706895153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "middle-georgia-state-university---macon-campus",
      "poi_latitude": "32.8109077",
      "poi_longitude": "-83.7326161",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-471-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f9-dfa1-726c-80e1-affa43220428",
        "storage_key": "property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkX-PZwD784gRMV8moerflcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2e31dd6d-5499-47de-af02-d5aa39352ca5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Wesleyan College",
      "poi_type": "Education",
      "poi_address": "4760 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-72c1-709d-b4aa-158902d5d10a.webp",
      "poi_featured_image_media": {
        "alt_text": "Wesleyan College campus exterior with a banner that reads \"First for Women Wesleyan\"",
        "public_id": "019d54f9-72c1-709d-b4aa-158902d5d10a",
        "storage_key": "property/6767906449167337/019d54f9-72c1-709d-b4aa-158902d5d10a.webp",
        "width": 1500,
        "height": 843
      },
      "poi_business_url": "https://www.wesleyancollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127112479690987328&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wesleyan-college",
      "poi_latitude": "32.87495560000001",
      "poi_longitude": "-83.7142284",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-447-6610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f9-dfa1-726c-80e1-affa43220428",
        "storage_key": "property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp7ZxsQH584gRQBeU9j_fLLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_177ba145-91d5-4e17-b079-b459a4fbb29e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Central Georgia Technical College",
      "poi_type": "Education",
      "poi_address": "3300 Macon Tech Dr, Macon, GA 31206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-76a7-762a-9bed-fc1f152326b7.webp",
      "poi_featured_image_media": {
        "alt_text": "Central Georgia Technical College monument sign",
        "public_id": "019d54f9-76a7-762a-9bed-fc1f152326b7",
        "storage_key": "property/6767906449167337/019d54f9-76a7-762a-9bed-fc1f152326b7.webp",
        "width": 1200,
        "height": 564
      },
      "poi_business_url": "http://www.centralgatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18192433639691018213&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-georgia-technical-college",
      "poi_latitude": "32.8125938",
      "poi_longitude": "-83.69185379999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-757-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f9-dfa1-726c-80e1-affa43220428",
        "storage_key": "property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuxynK-z784gR5V-m9QGCePw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_eb86cc4b-548a-4688-86d6-b4804b81e626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "156 Tom Hill Sr Blvd, Macon, GA 31210, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a wide variety of attractions, including go-karts, trampolines, obstacle courses, and a zip line. They also highlight the friendly and patient staff, and the fun and safe atmosphere.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-7573-7005-9126-1710a9bdf6ca.webp",
      "poi_featured_image_media": {
        "alt_text": "Children celebrating a birthday party with a cake and balloons.",
        "public_id": "019d54f9-7573-7005-9126-1710a9bdf6ca",
        "storage_key": "property/6767906449167337/019d54f9-7573-7005-9126-1710a9bdf6ca.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.urbanair.com/georgia-macon/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2863878912371504617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.9000907",
      "poi_longitude": "-83.6908497",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 478-273-8783",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0HUSUj584gR6bWig7KKvic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_7a95fd03-9a71-41bd-b334-dbd27a429dbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Museum of Arts and Sciences",
      "poi_type": "Entertainment",
      "poi_address": "4182 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "Museum featuring fine-arts & science galleries, interactive exhibits, a minizoo & a planetarium.",
      "poi_long_description": "People say this museum offers a variety of interactive displays, a planetarium, and a mini zoo. They highlight the reasonable admission price and the fun, educational experience for children. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-7ad8-7073-96a9-961e682a6a07.webp",
      "poi_featured_image_media": {
        "alt_text": "Museum of Arts & Sciences building exterior with brick facade and modern entrance.",
        "public_id": "019d54f9-7ad8-7073-96a9-961e682a6a07",
        "storage_key": "property/6767906449167337/019d54f9-7ad8-7073-96a9-961e682a6a07.webp",
        "width": 2880,
        "height": 1920
      },
      "poi_business_url": "https://www.masmacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10200504975877659134&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-arts-and-sciences",
      "poi_latitude": "32.8648216",
      "poi_longitude": "-83.695182",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 478-477-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfc6-745f-ab1e-a71b0a175d04.webp",
      "poi_map_icon_media": {
        "alt_text": "Property logo",
        "public_id": "019d54f9-dfc6-745f-ab1e-a71b0a175d04",
        "storage_key": "property/6767906449167337/019d54f9-dfc6-745f-ab1e-a71b0a175d04.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_E6OCP584gR_tnKIDt5j40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9047be16-651f-4e0f-b6cc-6b787de3e204",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "The Allman Brothers Band Museum at The Big House",
      "poi_type": "Entertainment",
      "poi_address": "2321 Vineville Ave, Macon, GA 31204, USA",
      "poi_short_description": "Museum honoring The Allman Brothers Band, with original instruments, art & personal mementos.",
      "poi_long_description": "People say this museum offers a fantastic collection of Allman Brothers Band memorabilia, including guitars, instruments, gold records, clothing, and personal items. They highlight the well-organized and informative exhibits, and the opportunity to explore the band's former home. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-817a-7123-a4bc-497c3a6f8eed.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Tudor-style apartment building with a manicured lawn and pathway.",
        "public_id": "019d54f9-817a-7123-a4bc-497c3a6f8eed",
        "storage_key": "property/6767906449167337/019d54f9-817a-7123-a4bc-497c3a6f8eed.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.thebighousemuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11318196558373350832&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-allman-brothers-band-museum-at-the-big-house",
      "poi_latitude": "32.8460043",
      "poi_longitude": "-83.6558957",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-741-5551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfc6-745f-ab1e-a71b0a175d04.webp",
      "poi_map_icon_media": {
        "alt_text": "Property logo",
        "public_id": "019d54f9-dfc6-745f-ab1e-a71b0a175d04",
        "storage_key": "property/6767906449167337/019d54f9-dfc6-745f-ab1e-a71b0a175d04.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzBD9pX-84gRsG3kr81PEp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0b8f60c4-85b7-4cf3-b4d4-a80db9a3640b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Five Star Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1327 Stadium Dr, Macon, GA 31207, USA",
      "poi_short_description": "Venue for college football games and lacrosse, plus graduation ceremonies and other events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-7e05-751e-b972-dc65baf8176c.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a college campus football stadium and baseball field.",
        "public_id": "019d54f9-7e05-751e-b972-dc65baf8176c",
        "storage_key": "property/6767906449167337/019d54f9-7e05-751e-b972-dc65baf8176c.webp",
        "width": 2000,
        "height": 1125
      },
      "poi_business_url": "http://mercer.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15190185259058354414&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "five-star-stadium",
      "poi_latitude": "32.8267522",
      "poi_longitude": "-83.6528574",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 478-796-5146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-df8d-74b6-a596-e1d0c7e9eb3c.webp",
      "poi_map_icon_media": {
        "alt_text": "Property management logo",
        "public_id": "019d54f9-df8d-74b6-a596-e1d0c7e9eb3c",
        "storage_key": "property/6767906449167337/019d54f9-df8d-74b6-a596-e1d0c7e9eb3c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhZtw6iD884gR7liMFgNhztI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_3ed953db-e794-40ea-972b-d64ee1352fa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Hawkins Arena",
      "poi_type": "Entertainment",
      "poi_address": "1400 Coleman Ave, Macon, GA 31207, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this arena hosts sporting events and ceremonies, and is the home of the Mercer Bears. They highlight the venue is clean, cozy, and well-lit, with excellent sound and lighting graphics. They also like the easy access from both levels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-80cd-739a-90cc-653bf8f90171.webp",
      "poi_featured_image_media": {
        "alt_text": "Basketball arena with orange seats and court.",
        "public_id": "019d54f9-80cd-739a-90cc-653bf8f90171",
        "storage_key": "property/6767906449167337/019d54f9-80cd-739a-90cc-653bf8f90171.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://mercerbears.com/sports/2016/5/22/athleticDept-facilities-uc.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4727150959813108272&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hawkins-arena",
      "poi_latitude": "32.8288941",
      "poi_longitude": "-83.6518573",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 478-301-5470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJixsAPZ7-84gRMKJOn8A2mkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_ebb7f54c-4834-4455-8492-ac768d6fd7f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3648 Eisenhower Pkwy, Macon, GA 31206, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of new equipment, including row machines, and has tanning beds and recovery rooms. They highlight the gym is clean, spacious, and family-friendly, with ample parking and 24-hour access. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-8ce5-700d-9443-b0c25177b55d.webp",
      "poi_featured_image_media": {
        "alt_text": "People exercising on various gym equipment, including weight machines and cardio machines.",
        "public_id": "019d54f9-8ce5-700d-9443-b0c25177b55d",
        "storage_key": "property/6767906449167337/019d54f9-8ce5-700d-9443-b0c25177b55d.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10090828296603436052&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.814771",
      "poi_longitude": "-83.68987899999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-292-6590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_P6Qtr784gRFASCTN_SCYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_f3d39da8-d57a-488d-aaeb-02feecba1ea5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Legends Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4551 Billy Williamson Dr, Macon, GA 31206, USA",
      "poi_short_description": "Kid-friendly sports complex with free weights and an airy space, plus basketball courts and a pool.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, protein powders, and pre-workout supplements, and has a semi-Olympic pool, hydro jet massage Jacuzzi, and sauna. They highlight the clean and spacious environment, the well-maintained equipment, and the friendly and supportive community. They also like the convenient childcare center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-8e53-76fa-b44b-ae78f22f8ddb.webp",
      "poi_featured_image_media": {
        "alt_text": "Spacious gym with various fitness equipment, including weight machines, free weights, and a functional training area with artificial turf.",
        "public_id": "019d54f9-8e53-76fa-b44b-ae78f22f8ddb",
        "storage_key": "property/6767906449167337/019d54f9-8e53-76fa-b44b-ae78f22f8ddb.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://maconlegends.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11119267159242364810&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "legends-fitness",
      "poi_latitude": "32.8220252",
      "poi_longitude": "-83.7148971",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 478-259-3849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlaEsuAz784gRitdOpZGST5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_25b45981-6e52-4550-809c-820779206b57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "B. Monroe Salon Macon",
      "poi_type": "Health and Wellness",
      "poi_address": "1520 Bass Rd, Macon, GA 31210, USA",
      "poi_short_description": "Upscale salon offering color treatments, highlights, hair extensions and blowouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-9385-7006-af7f-0346d2600ef1.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior signage for B. Monroe Salon on a brick building.",
        "public_id": "019d54f9-9385-7006-af7f-0346d2600ef1",
        "storage_key": "property/6767906449167337/019d54f9-9385-7006-af7f-0346d2600ef1.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.bmonroesalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12852327241260608403&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "b-monroe-salon-macon",
      "poi_latitude": "32.9269341",
      "poi_longitude": "-83.7380527",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-474-4856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUHbHRz584gRkytqCIijXLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_a402907b-d629-41df-b1ab-984abcd64d6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Hudspeth Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "510 Pio Nono Ave, Macon, GA 31204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-8d47-72ba-8121-2062da6d4be8.webp",
      "poi_featured_image_media": {
        "alt_text": "Huds peth animal hospital sign open 24 hours",
        "public_id": "019d54f9-8d47-72ba-8121-2062da6d4be8",
        "storage_key": "property/6767906449167337/019d54f9-8d47-72ba-8121-2062da6d4be8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.hudspethanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1164194923902499357&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hudspeth-animal-hospital",
      "poi_latitude": "32.841693",
      "poi_longitude": "-83.662081",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 478-742-8766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYSlaLv-84gRHXqFeB0NKBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_af078060-56f1-47cc-9207-54f13c46f1c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Macon - Plantation Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "5932 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-8ecf-716c-995b-5d81631fe828.webp",
      "poi_featured_image_media": {
        "alt_text": "A barber cuts a man's hair in a Sport Clips salon.",
        "public_id": "019d54f9-8ecf-716c-995b-5d81631fe828",
        "storage_key": "property/6767906449167337/019d54f9-8ecf-716c-995b-5d81631fe828.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://sportclips.com/us-ga-macon-ga601?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=12431992480645189209&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-macon---plantation-centre",
      "poi_latitude": "32.8782769",
      "poi_longitude": "-83.7593697",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-254-8530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkS5609T584gRWQ4vK0tPh6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_c9c89c9f-c981-4fad-8937-014990aa52ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Dapper Cuts Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "4524 Forsyth Rd #309, Macon, GA 31210, USA",
      "poi_short_description": "Unpretentious barber shop offering classic cuts, shaves and beard trims alongside some hair braiding.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-9d40-725e-bd5e-dee3f4dc12c1.webp",
      "poi_featured_image_media": {
        "alt_text": "A group of four barbers, three men and one woman, smiling at the camera.",
        "public_id": "019d54f9-9d40-725e-bd5e-dee3f4dc12c1",
        "storage_key": "property/6767906449167337/019d54f9-9d40-725e-bd5e-dee3f4dc12c1.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://dappercutsbarbershop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12334499415317741019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dapper-cuts-barbershop",
      "poi_latitude": "32.8716207",
      "poi_longitude": "-83.70505829999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 478-216-5620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_Fzxi7584gR2_1GBN7xLKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_3e186f15-fcec-4580-93ad-1786e00246cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "159 Tom Hill Sr Blvd Ste A, Macon, GA 31210, USA",
      "poi_short_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-9c24-74b9-9e47-5a050c61515e.webp",
      "poi_featured_image_media": {
        "alt_text": "Great Clips online check-in app shown on two iPhones.",
        "public_id": "019d54f9-9c24-74b9-9e47-5a050c61515e",
        "storage_key": "property/6767906449167337/019d54f9-9c24-74b9-9e47-5a050c61515e.webp",
        "width": 680,
        "height": 383
      },
      "poi_business_url": "https://salons.greatclips.com/us/ga/macon/159-tom-hill-sr-blvd?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4190334762914518172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "32.8985562",
      "poi_longitude": "-83.6875632",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 478-474-8409",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ84lk4rf484gRnJR9-UMPJzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_045e979b-0db8-4c21-ab2f-77b3f3347b1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Northside Wesleyan Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "335 Charter Blvd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-9fab-7071-a236-f150995b9421.webp",
      "poi_featured_image_media": {
        "alt_text": "A black cat with green eyes looking at the camera.",
        "public_id": "019d54f9-9fab-7071-a236-f150995b9421",
        "storage_key": "property/6767906449167337/019d54f9-9fab-7071-a236-f150995b9421.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://northsidewesleyanah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18403314624311928623&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northside-wesleyan-animal-hospital",
      "poi_latitude": "32.868043",
      "poi_longitude": "-83.6929033",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-477-6828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcOVdiT584gRLyfdVyW1Zf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_8985cb2e-8e3c-4038-a3cd-244b0267483f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Ingleside Beard & Barber",
      "poi_type": "Health and Wellness",
      "poi_address": "2389 Ingleside Ave, Macon, GA 31204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-a0bd-75f1-bc7f-3927fcb22ade.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a barbershop with chairs and stations.",
        "public_id": "019d54f9-a0bd-75f1-bc7f-3927fcb22ade",
        "storage_key": "property/6767906449167337/019d54f9-a0bd-75f1-bc7f-3927fcb22ade.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.ibbmacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6515820970108232040&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ingleside-beard--barber",
      "poi_latitude": "32.8539799",
      "poi_longitude": "-83.65686989999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 478-200-1365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ773ZzcH-84gRaKFXZ6bYbFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_ad7cfd27-fddd-40d4-af1b-4b920f8c0f49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Piedmont Macon North",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Charter Blvd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-a05d-77df-921c-860cc791a32a.webp",
      "poi_featured_image_media": {
        "alt_text": "Coliseum Northside Hospital main entrance with signage and surrounding grounds.",
        "public_id": "019d54f9-a05d-77df-921c-860cc791a32a",
        "storage_key": "property/6767906449167337/019d54f9-a05d-77df-921c-860cc791a32a.webp",
        "width": 1500,
        "height": 923
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-macon-north-hospital?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MjY4OTU4OTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17716511181231489673&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piedmont-macon-north",
      "poi_latitude": "32.8715199",
      "poi_longitude": "-83.6945317",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 478-757-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa0-727e-a80a-d1e73c75ac24.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54f9-dfa0-727e-a80a-d1e73c75ac24",
        "storage_key": "property/6767906449167337/019d54f9-dfa0-727e-a80a-d1e73c75ac24.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ35QKcSP584gRiQKKoA2x3fU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9437950f-035f-4270-abce-4fdd610e0031",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Amerson River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2551 Pierce Dr N, Macon, GA 31204, USA",
      "poi_short_description": "This sprawling park with woods, wetlands & meadows offers a playground, canoe launch & trails.",
      "poi_long_description": "People say this park offers well-maintained walking trails, a playground, and access to a river for tubing and kayaking. They highlight the peaceful and relaxing atmosphere, and the beautiful natural scenery. They also like the clean facilities, including restrooms and pavilions. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-9ff0-764d-8300-3b28adffac5e.webp",
      "poi_featured_image_media": {
        "alt_text": "Stone monument entrance with archway and 'EMERSON RIVER PARK' sign.",
        "public_id": "019d54f9-9ff0-764d-8300-3b28adffac5e",
        "storage_key": "property/6767906449167337/019d54f9-9ff0-764d-8300-3b28adffac5e.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "http://maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6348967655751333775&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amerson-river-park",
      "poi_latitude": "32.8742247",
      "poi_longitude": "-83.6571728",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 478-803-0484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black christmas tree icon",
        "public_id": "019d54f9-dfa0-727e-a80a-d5b9772f3ca8",
        "storage_key": "property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRY3JciD_84gRj7eA03EQHFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e543ffb3-808e-47dd-bf3d-8c6adb4b2759",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Lake Tobesofkee Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6600 Moseley Dixon Rd, Lizella, GA 31052, USA",
      "poi_short_description": "Destination for camping, boating, fishing & swimming with 3 sandy beaches & play areas for kids.",
      "poi_long_description": "People say this park offers a clean and spacious beach area, a boat ramp with easy access, and a well-maintained picnic area. They highlight the warm water, the clearly marked swimming area, and the reasonable price. They also like the safe and peaceful vibe, and the helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-ab51-77ce-8598-ba520ab636b8.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic view of a lake and surrounding trees from a park area.",
        "public_id": "019d54f9-ab51-77ce-8598-ba520ab636b8",
        "storage_key": "property/6767906449167337/019d54f9-ab51-77ce-8598-ba520ab636b8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://laketobo.maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14823284184662501318&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-tobesofkee-recreation-area",
      "poi_latitude": "32.8272218",
      "poi_longitude": "-83.7743509",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-474-8770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black christmas tree icon",
        "public_id": "019d54f9-dfa0-727e-a80a-d5b9772f3ca8",
        "storage_key": "property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Z9TVrLw84gRxmd5x23its0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2ae10fef-9207-415e-a922-ea5dc3a79820",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Claystone Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6600 Moseley Dixon Rd, Lizella, GA 31052, USA",
      "poi_short_description": "Peaceful waterside park featuring playgrounds and picnic tables, as well as a campground.",
      "poi_long_description": "People say this park offers a campground with concrete pads, full hookups, and lake views, as well as a beach, playground, boating docks, pavilions, and a butterfly garden. They highlight the clean and well-maintained facilities, and the beautiful views of Lake Tobesofke. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-b1ea-77f8-b4c9-841d20fa19e9.webp",
      "poi_featured_image_media": {
        "alt_text": "View of a large body of water with trees on the grassy shore.",
        "public_id": "019d54f9-b1ea-77f8-b4c9-841d20fa19e9",
        "storage_key": "property/6767906449167337/019d54f9-b1ea-77f8-b4c9-841d20fa19e9.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14057912594320637475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "claystone-park",
      "poi_latitude": "32.8272218",
      "poi_longitude": "-83.7743509",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-474-8771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black christmas tree icon",
        "public_id": "019d54f9-dfa0-727e-a80a-d5b9772f3ca8",
        "storage_key": "property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8a2Qe7Hw84gRI774wwW9F8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b0e6b3e9-0989-4190-92f1-f330ea505089",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Henry Burns Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3298 Ridge Ave, Macon, GA 31204, USA",
      "poi_short_description": "Playground featuring slides, swings, seating and climbing apparatus, alongside a clean grassy area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-b331-727e-a80c-ae2b5ca341d6.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground area with slides, climbing structures, benches, and walking paths.",
        "public_id": "019d54f9-b331-727e-a80c-ae2b5ca341d6",
        "storage_key": "property/6767906449167337/019d54f9-b331-727e-a80c-ae2b5ca341d6.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6981447226312425361&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "henry-burns-park",
      "poi_latitude": "32.8560562",
      "poi_longitude": "-83.677639",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 478-751-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black christmas tree icon",
        "public_id": "019d54f9-dfa0-727e-a80a-d5b9772f3ca8",
        "storage_key": "property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SF9xjT584gRkf98VkMV42A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a50d7f51-8967-49e8-8d04-6ab378d5b51b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Claystone beach parking",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2200 Moseley Dixon Rd, Macon, GA 31220, USA",
      "poi_short_description": "Park with a public restroom, picnic tables, and beach area for swimming.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-b389-7102-a396-42367b6a87a7.webp",
      "poi_featured_image_media": {
        "alt_text": "Sandy beach and lake with trees and houses in background under a blue sky with white clouds.",
        "public_id": "019d54f9-b389-7102-a396-42367b6a87a7",
        "storage_key": "property/6767906449167337/019d54f9-b389-7102-a396-42367b6a87a7.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2498577074473086416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "claystone-beach-parking",
      "poi_latitude": "32.8265036",
      "poi_longitude": "-83.77536169999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
      "poi_map_icon_media": {
        "alt_text": "Black christmas tree icon",
        "public_id": "019d54f9-dfa0-727e-a80a-d5b9772f3ca8",
        "storage_key": "property/6767906449167337/019d54f9-dfa0-727e-a80a-d5b9772f3ca8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT3W0qLHw84gR0C3nd5y6rCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f4555d2e-2d51-432a-86b2-23cdbb345c77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Atrium Health Navicent The Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "777 Hemlock St, Macon, GA 31201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019dfec2-464f-7429-8b2f-4fafb4f37bdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfec2-464f-7429-8b2f-4fafb4f37bdd",
        "storage_key": "property/6767906449167337/019dfec2-464f-7429-8b2f-4fafb4f37bdd.webp",
        "width": 1091,
        "height": 614
      },
      "poi_business_url": "https://navicenthealth.org/service-center/the-medical-center?utm_source=GMB&utm_medium=Organic&utm_campaign=AHN",
      "poi_directions_map_url": "https://maps.google.com/?cid=5959506398997543211&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "atrium-health-navicent-the-medical-center",
      "poi_latitude": "32.8338321",
      "poi_longitude": "-83.6365537",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 478-633-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa0-727e-a80a-d1e73c75ac24.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54f9-dfa0-727e-a80a-d1e73c75ac24",
        "storage_key": "property/6767906449167337/019d54f9-dfa0-727e-a80a-d1e73c75ac24.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJccj0KX7-84gRK3nqvH5rtFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_98f92046-9a07-4557-935e-a988aa5b40a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Bibb County Board-Education",
      "poi_type": "Major Employers & Offices",
      "poi_address": "484 Mulberry St, Macon, GA 31201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9533765090498954208&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bibb-county-board-education",
      "poi_latitude": "32.8363249",
      "poi_longitude": "-83.6259887",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 478-765-8711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f9-dfa1-726c-80e1-affa43220428",
        "storage_key": "property/6767906449167337/019d54f9-dfa1-726c-80e1-affa43220428.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIe25wnr-84gR4MM1d9a8ToQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_59ab384f-3553-4520-a0a7-c07dcf6e4568",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Amazon Fulfillment Center - SAV3",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6803-6999 Skipper Rd, Macon, GA 31216, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this warehouse offers a wide variety of products.\n\nOther reviews mention deliveries can be delayed and customer service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019dfec2-468e-76bc-9da7-579b1023fc31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfec2-468e-76bc-9da7-579b1023fc31",
        "storage_key": "property/6767906449167337/019dfec2-468e-76bc-9da7-579b1023fc31.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3291098560530863186&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amazon-fulfillment-center---sav3",
      "poi_latitude": "32.7199156",
      "poi_longitude": "-83.7239077",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 478-345-8392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNbyHE97l84gRUtQ9LbRUrC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_74ab5c3c-70c2-4869-9664-6eb0c4a2c318",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Tractor Supply Co. - Macon Distribution Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "151 Tractor Dr, Macon, GA 31216, USA",
      "poi_short_description": "Distribution point for freight, with trailers and some reviews mentioning efficient service.",
      "poi_long_description": "People say this distribution service offers efficient unloading and a large yard. They also highlight the friendly staff and helpful security.\n\nOther reviews mention appointments can be strict.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019dfec2-477e-72bf-b9ee-2823c98b8c11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfec2-477e-72bf-b9ee-2823c98b8c11",
        "storage_key": "property/6767906449167337/019dfec2-477e-72bf-b9ee-2823c98b8c11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tractorsupply.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8875675807514510248&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tractor-supply-co---macon-distribution-center",
      "poi_latitude": "32.725277",
      "poi_longitude": "-83.732635",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 478-785-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSUk1Ojvl84gRqENuIB-8LHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "custom_db156ea7-81bf-44d0-9ab8-2fe078142f7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Graphic Packaging International Macon GA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Graphic Pkg, Macon, GA 31206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fc-72ba-772a-8ad9-394352d8beb5.webp",
      "poi_featured_image_media": {
        "alt_text": "Image of a facility with storage tanks and buildings under a cloudy sky.",
        "public_id": "019d54fc-72ba-772a-8ad9-394352d8beb5",
        "storage_key": "property/6767906449167337/019d54fc-72ba-772a-8ad9-394352d8beb5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.graphicpkg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5143895376103681438&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "graphic-packaging-international-macon-ga",
      "poi_latitude": "32.7738532",
      "poi_longitude": "-83.6307963",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 478-788-6160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d54f9-dfa6-714c-80a0-f5dedbe2eba4",
        "storage_key": "property/6767906449167337/019d54f9-dfa6-714c-80a0-f5dedbe2eba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT8c1Zx7984gRni1vTpfJYkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_abbfb955-5c30-452a-81e5-201c41f2cc33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "poi_name": "Fish N' Pig",
      "poi_type": "Restaurants",
      "poi_address": "6420 Moseley Dixon Rd, Macon, GA 31220, USA",
      "poi_short_description": "Deck dining available at this casual dining room with bar, combo platters & view of Lake Tobesofkee.",
      "poi_long_description": "Diners enjoy the restaurant's delicious fried catfish, blackened gator, and shrimp and corn chowder, along with a variety of seating options. The great atmosphere features live music and lake views.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019dfec2-47dd-7578-bb88-8bb4e6abff19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfec2-47dd-7578-bb88-8bb4e6abff19",
        "storage_key": "property/6767906449167337/019dfec2-47dd-7578-bb88-8bb4e6abff19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fishnpig.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6023852869721033553&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fish-n-pig",
      "poi_latitude": "32.8302345",
      "poi_longitude": "-83.77117919999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 478-476-8837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f9-dfba-72aa-a54e-479624a241d7",
        "storage_key": "property/6767906449167337/019d54f9-dfba-72aa-a54e-479624a241d7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSovr63w84gRUYvw7kQGmVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    }
  ],
  "office_hours": [
    {
      "id": "custom_54d571e5-e329-43f0-a1cb-be81f7841fcb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c913e5cb-3adf-4dac-aeb1-df3067a47c07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5828eb99-3d59-4bdc-afb4-783e53839a89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4acc3e43-d31d-40a8-8ab0-947d4262df1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_97e32c52-e0d2-4a85-91a3-2a3a2ef02ed2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0a962152-4db7-4f72-b3c1-4a8cc170ddc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_f17b530c-03c9-4b17-b991-43378fd4d9b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "Clarissa Dawson",
      "text": "I met with Ms. Sabrina for a tour and she was very welcoming, very personable, and professional. She explained things in a simplified manner where I can easily understand the expectations of the property as a tenant as well. Most people rush but I appreciate her patience with me a the question’s I asked, it shows property hospitality and that she values not only her position but her relationship with her resident tenants and prospects!",
      "date": "2025-09-25",
      "title": ""
    },
    {
      "id": "custom_f1070c88-0552-42aa-af3f-4fb905d76346",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "Fonkeng Saliki",
      "text": "I had a very good experience touring apartments with Sabrina. She answered every question I had thoroughly, she was very friendly. Additionally, she seem to know many residents by a first name basis which showed to me the additional care she takes in her job.",
      "date": "2025-10-22",
      "title": ""
    },
    {
      "id": "custom_830e8af6-a7a5-4b39-8d24-ba4b22c8f87c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "Kiantae Beautiful",
      "text": "Ms. Sabrina is truly God sent. She stayed true to me from the beginning. The apartments are very nice and very well kept. If I could rate more than 5 for her and the company itself, I’ll give it a 10 star 😊",
      "date": "2025-10-11",
      "title": ""
    },
    {
      "id": "custom_dc8cd65e-ae30-4a8c-b981-84bce250422b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "chosen4cj",
      "text": "Hunter Run/The Otis Apartments is a beautiful community. The apartment’s are beautiful, spacious and bright. It’s a wonderful place to live and great pricing. The Leasing Consultant Sabrina is great in explaining everything and has a welcoming personality.\n\nI do feel they should invest in having their literature updated so not to confused the potential residents of the name of community and floor plans.",
      "date": "2025-09-30",
      "title": ""
    },
    {
      "id": "custom_2a6b7356-0896-4a3a-83bc-2a0c739d6e1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "J C",
      "text": "I enjoyed my tour with Ms.Sabrina, she was very sweet. She showed really great hospitality. The tour of the apartment was nice also! Very bright",
      "date": "2025-12-01",
      "title": ""
    },
    {
      "id": "custom_8490c488-240a-4a8b-8c0b-b49de3c878ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "Jamesha Alexander",
      "text": "I had a wonderful experience working with Ms. Sabrina. From the very beginning, she were professional, knowledgeable, and responsive to all of my questions. She made the entire leasing process smooth and stress-free, keeping me informed every step of the way. Her friendly attitude and dedication to helping me find the right home truly stood out. I appreciate her patience, attention to detail, and excellent customer service. I would highly recommend her to anyone looking for a positive and seamless leasing experience. Thank you for all your help!”\n\n-JaMesha B.Alexander",
      "date": "2026-06-20",
      "title": ""
    },
    {
      "id": "custom_fa843354-1d25-449a-b963-448f2bfea322",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "TyLese",
      "text": "I came in on a rainy day wanting to tour the apartment. Mrs. Sabrina was so nice & accommodating! She took me on an amazing tour. She's very kind, professional, & caring. Most importantly you can tell she cares about not only her job, but her residents & the community! We discussed my needs & wants and she's going to make it happen! She's such a blessing! Shout out to Mrs. Sabrina!",
      "date": "2026-06-16",
      "title": ""
    },
    {
      "id": "custom_5008f446-4fc7-4cba-b7de-72d7910433ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "MarKayla Mathews",
      "text": "Sabrina was absolutely amazing throughout our entire apartment search process! She was professional, patient, honest, and genuinely made us feel comfortable from start to finish. She took the time to answer every question we had, explained everything clearly, and showed us multiple apartment styles so we could truly find the best fit for us.\n\nWhat stood out the most was how real and friendly she was — she never made us feel rushed or pressured, and her energy made the experience so much easier and enjoyable. You can tell she truly cares about helping people, not just leasing apartments. Thank you again, Sabrina, for going above and beyond for us! 🤍",
      "date": "2026-05-13",
      "title": ""
    },
    {
      "id": "custom_ea5725f2-addd-4f5e-874a-d4d5b8fdbb1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "Kanako Adachi-Gray",
      "text": "We had a great tour with Ms. Sabrina. She is incredibly caring, friendly, and professional. We really appreciated that she wasn't pushy at all. It was also wonderful to see how she interacted with the other staff and residents. We can tell that it's a wonderful community.",
      "date": "2026-06-01",
      "title": ""
    },
    {
      "id": "custom_b458a615-f92a-44ee-84c3-090be079e3af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "rating": "5.0",
      "name": "A. Rowan",
      "text": "Sabrina gave us a tour. She was absolutely lovely, answered all of our questions and was very patient and accommodating with the rain we dealt with. The property was lovely as well and the community seems to be incredibly open and kind!",
      "date": "2026-06-16",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_50b0865d1a0dd2ec4ccb3134",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "2BR, 2BA -1,230SF.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fb-a11a-77e7-9cac-4830b93ac16e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54fb-a11a-77e7-9cac-4830b93ac16e",
        "storage_key": "property/6767906449167337/019d54fb-a11a-77e7-9cac-4830b93ac16e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA -1,230SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=TRdNJiXrCdQ"
    },
    {
      "id": "ec_59212f480c3ed683812c6294",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Clubhouse.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fb-a10f-752a-b3cc-3fbd28f6da26.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54fb-a10f-752a-b3cc-3fbd28f6da26",
        "storage_key": "property/6767906449167337/019d54fb-a10f-752a-b3cc-3fbd28f6da26.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oJsAfuvPqBD"
    },
    {
      "id": "ec_690edc193bbd19ad0598dacb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Fitness Center.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fb-a207-7111-9f70-0ac510af6280.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54fb-a207-7111-9f70-0ac510af6280",
        "storage_key": "property/6767906449167337/019d54fb-a207-7111-9f70-0ac510af6280.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nw5nUy6Fj9T"
    },
    {
      "id": "ec_c558f1d145deaeda63b17fd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Business Center.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fb-a1e3-7650-a363-793a2298ccbf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54fb-a1e3-7650-a363-793a2298ccbf",
        "storage_key": "property/6767906449167337/019d54fb-a1e3-7650-a363-793a2298ccbf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QfbYq4JxuSy"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-d426-726e-b9bd-039fa6714d80",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Otis Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337"
    },
    {
      "lead_collector_id": "019db23f-d497-74d8-b5a4-5fc15ec7b085",
      "lead_source": "FACEBOOK_ADS",
      "name": "The Otis Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337"
    },
    {
      "lead_collector_id": "019db23f-d506-75a8-806f-a00a82c6532a",
      "lead_source": "LANDING_PAGE",
      "name": "The Otis Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-macon-ga",
      "search_query": "pet friendly apartments Macon GA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Macon, GA",
      "h2_subtitle": "Discover pet friendly apartments in Macon, GA that cater to both you and your furry friends. The Otis offers the perfect space for you and your pets.",
      "page_copy": "At The Otis in Macon, GA, we warmly welcome you and your furry companions. Our pet friendly apartments provide the ideal environment for both cat and dog lovers. Located in the vibrant heart of Macon, The Otis is a gated community, ensuring a safe and secure home for your pet.\n\nInside our stylish apartments, find modern touches like quartz countertops and kitchen islands, perfect for daily living and entertaining. With convenient washer/dryer connections, household chores are a breeze, allowing more time to enjoy the nearby pet parks and walking trails. Choose The Otis for a lifestyle where pets are welcome.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Macon, GA",
      "seo_description": "Find pet friendly apartments in Macon, GA. Enjoy spacious layouts, modern amenities, and a welcoming environment at The Otis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "apartments-poolside-grilling-bibb-county",
      "search_query": "apartments with poolside grilling Bibb County",
      "category": "Amenity",
      "h1_title": "Apartments with Poolside Grilling in Bibb County",
      "h2_subtitle": "Enjoy poolside grilling at The Otis, located in Bibb County, GA. Experience spacious living with modern amenities in a vibrant community.",
      "page_copy": "Look no further than The Otis in Bibb County, GA for an exceptional living experience with poolside grilling. Our community embraces a lively lifestyle that includes relaxing by the pool and enjoying delicious meals at our dedicated grilling areas. Here, you can entertain friends or simply unwind in style.\n\nOur apartments feature beautiful quartz countertops and kitchen islands, ideal for food preparation and hosting get-togethers. You'll appreciate the convenience of washer/dryer connections and our pet-friendly policy, making The Otis the perfect place to call home. Situated in a gated community, enjoy safety and serenity while making lasting memories with loved ones.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Poolside Grilling in Bibb County",
      "seo_description": "Discover apartments with poolside grilling in Bibb County. Experience modern amenities and community living at The Otis.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "dog-park-apartments-near-highway-475",
      "search_query": "dog park apartments near Highway 475",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near Highway 475",
      "h2_subtitle": "Find apartments near Highway 475 with a dedicated dog park. At The Otis, your pets are family and have plenty of space to play.",
      "page_copy": "Introducing The Otis, a perfect community for pet owners seeking dog park apartments near Highway 475. Located in the bustling area of Macon, GA, our apartments offer easy access to major roads, making travel convenient while providing a haven for your furry friends.\n\nEnjoy a modern living space complete with features like quartz countertops and kitchen islands, ideal for both convenience and comfort. Within our pet-friendly community, discover a welcoming environment with facilities that ensure your pets' happiness, including access to nearby dog-friendly areas. The Otis makes it easy to balance busy life with moments of relaxation and play.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near Highway 475",
      "seo_description": "Explore dog park apartments near Highway 475 at The Otis. Enjoy convenient living with pet-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "gated-community-apartments-fitness-center-31220",
      "search_query": "gated community apartments with fitness center in 31220",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments with Fitness Center",
      "h2_subtitle": "Explore gated community apartments with a fitness center in the 31220 area. The Otis offers modern living with top-notch amenities.",
      "page_copy": "Welcome to The Otis, a premiere gated community offering exceptional apartments with a fitness center in the 31220 area of Macon, GA. Our property not only provides enhanced security and privacy but also gives residents access to a state-of-the-art fitness facility.\n\nExperience elegant living with features like quartz countertops and kitchen islands, making daily life both stylish and convenient. The Otis ensures all residents have a high-quality lifestyle, with pet-friendly policies and convenient washer/dryer connections, creating the perfect balance of comfort and functionality inside our beautifully designed community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apts with Fitness Center in 31220",
      "seo_description": "Discover gated community apartments with a fitness center in 31220 at The Otis. Enjoy modern amenities in a secure environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "washer-dryer-connections-apartments-macon-ga",
      "search_query": "washer dryer connections apartments Macon GA",
      "category": "Amenity",
      "h1_title": "Washer Dryer Connections Apartments in Macon, GA",
      "h2_subtitle": "Find apartments with washer dryer connections in Macon, GA. Enjoy urban conveniences at The Otis with this essential feature.",
      "page_copy": "Discover the ease of living at The Otis, where our apartments in Macon, GA, come equipped with washer dryer connections. Perfect for those who value convenience and efficiency in their home, this feature makes laundry day a breeze.\n\nIn addition to this, explore a variety of additional amenities such as beautiful quartz countertops, a modern kitchen island, and a welcoming pet-friendly environment. Situated conveniently in Macon, The Otis offers a blend of comfort and modern living, ideal for anyone seeking a vibrant community experience in Georgia.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Connections Apts in Macon, GA",
      "seo_description": "Explore The Otis in Macon, GA for apartments with washer dryer connections. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-macon-ga",
      "search_query": "1 bedroom apartments macon ga",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Macon, GA",
      "h2_subtitle": "Discover stylish 1 bedroom apartments in Macon, GA. The Otis offers contemporary living spaces with top amenities.",
      "page_copy": "Welcome to The Otis, offering exquisite 1 bedroom apartments in the heart of Macon, GA. Our units are designed to combine style and functionality, perfect for singles or couples seeking a comfortable home base.\n\nEach apartment boasts modern amenities, including quartz countertops and kitchen islands for easy meal prep. As a pet-friendly community with a variety of specialized facilities, The Otis ensures a perfect balance of tranquility and convenience. Enjoy living in a bustling city while experiencing the personal touch and warm hospitality that The Otis provides.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Macon, GA",
      "seo_description": "Find your new home with our 1 bedroom apartments in Macon, GA at The Otis. Experience stylish living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-bibb-county",
      "search_query": "2 bedroom apartments bibb county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Bibb County",
      "h2_subtitle": "Explore spacious 2 bedroom apartments in Bibb County. The Otis provides the ideal setting for comfortable and modern living.",
      "page_copy": "Discover the spacious 2 bedroom apartments available at The Otis, located in beautiful Bibb County. Perfect for families or roommates, our apartments offer ample space and stylish design features like quartz countertops and kitchen islands that enhance your living experience.\n\nThe Otis is a gated community, ensuring peace of mind while enjoying community amenities. With pet-friendly policies and convenient washer/dryer connections, our property caters to all of life's needs. Experience the best of Bibb County living, where convenience and comfort are nestled within vibrant surroundings.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments, Bibb County",
      "seo_description": "Find spacious 2 bedroom apartments in Bibb County at The Otis. Enjoy comfort and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "3-bedroom-apartments-near-31220",
      "search_query": "3 bedroom apartments near 31220",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 31220",
      "h2_subtitle": "Spacious 3 bedroom apartments near 31220 offer ample living space. Discover modern amenities at The Otis in Macon, GA.",
      "page_copy": "If you're searching for roomy 3 bedroom apartments near the 31220 area, look no further than The Otis in Macon, GA. Our apartments are crafted to provide abundant space while maintaining a cozy, homey feel, perfect for families or professionals needing extra room.\n\nThe Otis ensures a superior living experience with top-tier amenities, including elegant quartz countertops and functional kitchen islands. Our gated community offers a pet-friendly environment complete with washer/dryer connections, making your lifestyle as comfortable as possible. Enjoy living near 31220 and experience the perfect blend of convenience and comfort at The Otis.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 31220",
      "seo_description": "Explore The Otis for spacious 3 bedroom apartments near 31220, Macon, GA. Enjoy modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "apartments-near-mercer-university-macon-ga",
      "search_query": "apartments near Mercer University Macon GA",
      "category": "School",
      "h1_title": "Apartments Near Mercer University, Macon",
      "h2_subtitle": "Discover convenient apartments near Mercer University in Macon, GA. The Otis offers modern living close to campus.",
      "page_copy": "Situated just a short drive from Mercer University, The Otis offers ideal apartments for students, faculty, and staff seeking a quality living experience in Macon, GA. Our thoughtfully designed community combines convenience and style, making it easy to balance academics and leisure.\n\nThe Otis features contemporary amenities like quartz countertops, kitchen islands, and washer/dryer connections, enhancing everyday living. With our pet-friendly and gated community, residents enjoy a secure and convenient lifestyle. Whether you're studying or teaching, find the perfect home near Mercer University at The Otis.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mercer University, Macon",
      "seo_description": "Find the perfect apartments near Mercer University, Macon at The Otis. Enjoy modern amenities and convenient location close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "apartments-close-to-middle-georgia-state-university-macon-campus",
      "search_query": "apartments close to Middle Georgia State University Macon Campus",
      "category": "School",
      "h1_title": "Apartments Near Middle Georgia State University",
      "h2_subtitle": "Find comfortable apartments close to Middle Georgia State University, Macon Campus. The Otis offers modern amenities just minutes away.",
      "page_copy": "Looking for apartments close to Middle Georgia State University, Macon Campus? The Otis provides an excellent living option for students and faculty seeking both convenience and comfort. Our community is strategically located to offer quick access to the campus, allowing you to spend more time focusing on your studies or work.\n\nThe Otis features modern amenities such as elegant quartz countertops, kitchen islands, and in-unit washer/dryer connections. Our gated, pet-friendly community ensures a secure and pleasant living environment. Choose The Otis and enjoy a blend of contemporary style and proximity to Middle Georgia State University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Middle Georgia State University",
      "seo_description": "Discover The Otis for comfortable apartments close to Middle Georgia State University, Macon Campus. Enjoy modern amenities just minutes away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "apartments-near-wesleyan-college-bibb-county",
      "search_query": "apartments near Wesleyan College Bibb County",
      "category": "School",
      "h1_title": "Apartments Near Wesleyan College, Bibb County",
      "h2_subtitle": "Explore quality apartments near Wesleyan College in Bibb County. The Otis offers an ideal living space for students and staff.",
      "page_copy": "The Otis apartments present a prime living opportunity near Wesleyan College in Bibb County. Perfectly suited for students and faculty, our community ensures you enjoy a comfortable lifestyle while being just a short commute from campus. \n\nEach apartment is designed with your needs in mind, featuring modern amenities such as quartz countertops and functional kitchen islands. The gated, pet-friendly environment, paired with washer/dryer connections, promises convenience and peace of mind. Choose The Otis for a harmonious blend of location and quality amenities close to Wesleyan College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wesleyan College, Bibb County",
      "seo_description": "Find ideal apartments near Wesleyan College in Bibb County at The Otis. Enjoy a convenient and modern living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "apartments-close-to-central-georgia-technical-college-macon-31220",
      "search_query": "apartments close to Central Georgia Technical College Macon 31220",
      "category": "School",
      "h1_title": "Apartments Close to Central Georgia Tech College",
      "h2_subtitle": "Discover convenient apartments close to Central Georgia Technical College in Macon, GA 31220. The Otis offers a perfect blend of comfort and style.",
      "page_copy": "Located just moments from Central Georgia Technical College, The Otis offers the ideal apartments for students and professionals in the Macon, GA area. Our community is designed to provide both convenience and modern living within the 31220 zip code.\n\nEnjoy our spacious apartments featuring quartz countertops, kitchen islands, and washer/dryer connections. Whether you need a peaceful study environment or a place to unwind, our pet-friendly and gated community supports your lifestyle. Experience the ease of living near Central Georgia Technical College at The Otis, where quality meets location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Central Georgia Tech College",
      "seo_description": "Explore The Otis for modern apartments close to Central Georgia Technical College in Macon, GA 31220. Ideal for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "apartments-near-piedmont-macon-north-ga",
      "search_query": "apartments near Piedmont Macon North GA",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Macon North, GA",
      "h2_subtitle": "Discover premium living in apartments near Piedmont Macon North, GA. The Otis offers elegance and proximity within the heart of Macon.",
      "page_copy": "When searching for apartments near Piedmont Macon North in GA, consider The Otis as your ideal choice. Our community provides a comfortable and convenient living space just minutes away from the medical facility, perfect for healthcare professionals.\n\nExperience the blend of style and convenience with amenities like quartz countertops, spacious kitchen islands, and washer/dryer connections in every apartment. Our gated, pet-friendly community ensures peace of mind while offering a welcoming environment. Live close to work and enjoy the perks of The Otis, where quality meets convenience near Piedmont Macon North.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Macon North, GA",
      "seo_description": "Find convenient living at The Otis, apartments near Piedmont Macon North in GA. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "apartments-near-amerson-river-park-macon-ga",
      "search_query": "apartments near amerson river park macon ga",
      "category": "Park",
      "h1_title": "Apartments Near Amerson River Park, Macon GA",
      "h2_subtitle": "Experience the charm of living in apartments near Amerson River Park in Macon, GA. The Otis offers a serene and well-situated community.",
      "page_copy": "Nestled near the scenic Amerson River Park in Macon, GA, The Otis presents the perfect blend of nature and urban living. Our apartments provide quick access to the park's picturesque trails and recreational areas, making it an ideal location for outdoor enthusiasts.\n\nEnjoy luxury with features such as quartz countertops, kitchen islands, and washer/dryer connections in each unit. A pet-friendly and gated atmosphere ensures a peaceful, secure environment. Experience the best of both worlds at The Otis, where you can relax at home or explore the beautiful surroundings of Amerson River Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Amerson River Park, Macon GA",
      "seo_description": "Explore The Otis for serene living in apartments near Amerson River Park, Macon GA. Enjoy nature and modern comforts in our well-situated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "lake-tobesofkee-recreation-area-apartments",
      "search_query": "lake tobesofkee recreation area apartments",
      "category": "Park",
      "h1_title": "Lake Tobesofkee Recreation Area Apartments",
      "h2_subtitle": "Find ideal apartments near Lake Tobesofkee Recreation Area. The Otis offers a blend of comfort and convenience in a prime Macon, GA location.",
      "page_copy": "Discover the perfect living space near Lake Tobesofkee Recreation Area with The Otis apartments. Our community offers easy access to the lake's beautiful shores and recreational facilities, ideal for those who appreciate the great outdoors and serene environments.\n\nFeaturing modern amenities like quartz countertops, kitchen islands, and washer/dryer connections, our apartments provide style and convenience. Experience the tranquility of a pet-friendly, gated community while being close to the natural beauty and activities of Lake Tobesofkee. Enjoy the best of lakeside living at The Otis, where comfort meets recreation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Tobesofkee Recreation Area Apartments",
      "seo_description": "Live near Lake Tobesofkee Recreation Area at The Otis. Enjoy modern amenities and lakeside convenience in Macon, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "the-otis-near-claystone-park-macon-ga",
      "search_query": "the otis near claystone park macon",
      "category": "Park",
      "h1_title": "The Otis Near Claystone Park, Macon",
      "h2_subtitle": "Explore living at The Otis, conveniently located near Claystone Park in Macon, GA. Enjoy seamless access to outdoor activities and modern amenities.",
      "page_copy": "At The Otis, you're just a stone's throw away from the scenic beauty of Claystone Park in Macon, a prime location for those who love outdoor adventures. Our community provides residents with peaceful surroundings while being close to the park's recreational offerings.\n\nOur apartments feature high-quality finishes, including quartz countertops, kitchen islands, and in-unit washer/dryer connections. As a gated, pet-friendly community, we ensure a secure and welcoming environment for all residents. Choose The Otis for a lifestyle that combines nature's tranquility with modern comfort near Claystone Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Otis Near Claystone Park, Macon",
      "seo_description": "Live at The Otis, near Claystone Park, Macon, GA. Experience outdoor fun and modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "apartments-by-henry-burns-park-bibb-county",
      "search_query": "apartments by henry burns park bibb county",
      "category": "Park",
      "h1_title": "Apartments by Henry Burns Park, Bibb County",
      "h2_subtitle": "Find your next home at The Otis, offering apartments by Henry Burns Park in Bibb County. Enjoy peaceful living with easy park access.",
      "page_copy": "The Otis offers strategically located apartments near Henry Burns Park in Bibb County, providing an ideal spot for those who relish recreational activities and serene park views. Our community is perfect for families and individuals who appreciate having green spaces just a short distance away.\n\nEquipped with upscale features such as quartz countertops, kitchen islands, and washer/dryer connections, our apartments merge style with practicality. The gated, pet-friendly environment of The Otis offers security and comfort, making it an excellent choice for those seeking proximity to Henry Burns Park's natural beauty and amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Henry Burns Park, Bibb County",
      "seo_description": "Discover The Otis apartments by Henry Burns Park, Bibb County. Enjoy modern living with park access and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167337",
      "source": "custom",
      "page_item_url": "the-otis-close-to-claystone-beach-parking",
      "search_query": "the otis close to claystone beach parking",
      "category": "Park",
      "h1_title": "The Otis Close to Claystone Beach Parking",
      "h2_subtitle": "Enjoy convenience at The Otis, located close to Claystone Beach parking. Experience easy beach access and comfortable living in Macon, GA.",
      "page_copy": "At The Otis, you'll enjoy unparalleled convenience being close to Claystone Beach parking. This ideal location offers residents easy access to refreshing beach outings and picnics while being a short distance from the comforts of home.\n\nOur apartments feature modern perks such as quartz countertops and kitchen islands, paired with essentials like washer/dryer connections. As a gated, pet-friendly community, The Otis ensures a safe and welcoming atmosphere, perfect for those who value leisure and ease near Claystone Beach. Embrace a balanced lifestyle of relaxation and contemporary comforts at The Otis.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Otis Close to Claystone Beach Parking",
      "seo_description": "Live at The Otis, near Claystone Beach parking. Enjoy easy beach outings and modern amenities in a secure, pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6152"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671056693"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KSN88NH7"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "31274700124"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "c6534986811ee672"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "801720220"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw98k95po9"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "c32f10e50bdcbe39b4c6"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a1349e2a-d0cb-11f0-a5a5-c361b71fcb93"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://apollostore.blob.core.windows.net/otis/uploads/assets/otis-1.e70cf703.mp4"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a1349e2a-d0cb-11f0-a5a5-c361b71fcb93/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkhRZ1IydVQyd2RhSWhZcXNMaFlYRXc9PSIsInZhbHVlIjoiSU5xdGhmTWN3bUYyR3NpMFZPZUxwQT09IiwibWFjIjoiODk4YmZjYjcyM2Q4ZjA3YzYwYTgzNDg2YzEwNzMzODQ4ZGNhZDYyYWY2ZTRlMDJhYjc1N2EwYTBlOWRkNDk4ZSJ9"
    }
  ],
  "custom_qb_id": "6152",
  "custom_repli_id": "11671056693",
  "custom_google_gtm_id": "GTM-KSN88NH7",
  "custom_hubspot_company_id": "31274700124",
  "custom_knock_community_id": "c6534986811ee672",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "801720220",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dqw98k95po9",
  "custom_call_rail_account_hash": "c32f10e50bdcbe39b4c6",
  "custom_eliseai_building_token": "a1349e2a-d0cb-11f0-a5a5-c361b71fcb93",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_property_featured_video": "https://apollostore.blob.core.windows.net/otis/uploads/assets/otis-1.e70cf703.mp4",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a1349e2a-d0cb-11f0-a5a5-c361b71fcb93/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkhRZ1IydVQyd2RhSWhZcXNMaFlYRXc9PSIsInZhbHVlIjoiSU5xdGhmTWN3bUYyR3NpMFZPZUxwQT09IiwibWFjIjoiODk4YmZjYjcyM2Q4ZjA3YzYwYTgzNDg2YzEwNzMzODQ4ZGNhZDYyYWY2ZTRlMDJhYjc1N2EwYTBlOWRkNDk4ZSJ9",
  "custom_audioeye_site_id": "28b57fa8-a459-4682-91bd-f64342978789",
  "custom_audioeye_site_hash": "53fee7f3c0235548668f052ec59446f0"
};

export const generatedAt = '2026-10-01T17:22:53.902Z';
